/* Bundle Builder logic, externalized from sections/build-a-bundle.liquid to keep
   the section under Shopify's 256 KB limit. Loaded with `defer` from the section
   via {{ 'bab-bundle.js' | asset_url }}. PURE JS: all config is read from data-*
   attributes on #build-a-bundle and from window.__babTabConfig (set by the small
   inline script that remains in the section). TO INLINE AGAIN: paste everything
   below back between <script></script> where the external <script src> tag now
   sits in the section, then delete this asset file. */

(function() {
  var section = document.getElementById('build-a-bundle');
  if (!section) return;

  // ============ CONFIG (from data- attrs) ============
  // CRITICAL: data attrs with digits between hyphens (e.g. data-subtotal-tier-1-label)
  // do NOT convert cleanly via .dataset.X — the dataset spec only converts
  // hyphen-followed-by-lowercase-letter, so `data-subtotal-tier-1-label` becomes
  // dataset['subtotalTier-1Label'] (with literal hyphen), not dataset.subtotalTier1Label.
  // We use getAttribute() throughout to sidestep the conversion entirely.
  function attr(name) { return section.getAttribute('data-' + name); }
  function attrInt(name, fallback) {
    var raw = attr(name);
    if (raw == null || raw === '') return fallback;
    var n = parseInt(raw, 10);
    return isNaN(n) ? fallback : n;
  }
  function attrStr(name, fallback) {
    var v = attr(name);
    return (v == null || v === '') ? fallback : v;
  }

  var minItems       = attrInt('min-items', 2);
  var milestoneCount = attrInt('milestone-count', 4);
  var checkoutType   = attrStr('checkout-type', 'atc');
  var fakeCartPreview = attrStr('fake-cart-preview', 'false') === 'true';
  var market         = attrStr('market', 'worldwide');
  // Item-count "Buy N get 1 free" display (messaging only; the discount itself is a
  // separate Shopify automatic discount). Driven by paidCount = real products only.
  var qtyOfferOn     = attrStr('qty-offer', 'false') === 'true';
  var qtyBuyN        = attrInt('qty-offer-buy-n', 2);
  var qtyWord        = attrStr('qty-offer-word', 'piece');
  // Editable Buy-N-Get-1 message templates (theme customizer). Blank falls back
  // to the built-in default, so existing instances render unchanged.
  var qtyMsgProgress = attrStr('qty-offer-msg-progress', 'Add **[n] more [word]** to get one **FREE**.');
  var qtyMsgEarned   = attrStr('qty-offer-msg-earned', '**🎉 [earned] [word] FREE**! Add **[n] more [word]** for another.');
  var qtyMsgModal    = attrStr('qty-offer-msg-modal', 'Buy [buyn], get **[earned] [word] free** at checkout');
  // Editable progress-bar + review-modal text (theme customizer). Blank falls back to default.
  var textProgressEmpty  = attrStr('text-progress-empty', 'Add items to unlock free gifts and shipping.');
  var textProgressUnlock = attrStr('text-progress-unlock', 'Add **[amount]** to unlock your **[reward]**.');
  var textAllUnlocked    = attrStr('text-all-unlocked', 'All rewards unlocked 🎉');
  var textReviewTitle    = attrStr('text-review-title', 'Review Your Bundle');
  var textUnlockedSuffix = attrStr('text-unlocked-suffix', 'unlocked');
  // Fill a message template into setRichText parts. Tokens: [n] (items to next
  // free), [earned] (free items earned), [buyn] (the buy number), [word] (product
  // word, auto-pluralized on the number that precedes it). Wrap any span in
  // **double stars** to bold it. Returns {text}/{strong} parts for setRichText.
  function fillQtyTemplate(tpl, nums) {
    var lastNum = 1;
    var filled = String(tpl).replace(/\[(\w+)\]/g, function (_, key) {
      if (key === 'word' && nums.word != null) { return lastNum === 1 ? nums.word : nums.word + 's'; }
      var v = nums[key];
      if (v == null) { return '[' + key + ']'; }
      if (typeof v === 'number') { lastNum = v; }
      return v;
    });
    var segs = filled.split('**');
    var parts = [];
    for (var i = 0; i < segs.length; i++) {
      if (segs[i] === '') { continue; }
      parts.push(i % 2 === 1 ? { strong: segs[i] } : { text: segs[i] });
    }
    return parts;
  }
  var countTier1     = attrInt('count-tier-1', 2);
  var countTier1Pct  = attrInt('count-tier-1-pct', 10);
  var countTier2     = attrInt('count-tier-2', 4);
  var countTier2Pct  = attrInt('count-tier-2-pct', 20);
  var subTier1       = attrInt('subtotal-tier-1', 4000);
  var subTier1Label  = attrStr('subtotal-tier-1-label', 'Free Stickers');
  var subTier2       = attrInt('subtotal-tier-2', 5500);
  var subTier2Label  = attrStr('subtotal-tier-2-label', 'Free Shipping');
  var subTier3       = attrInt('subtotal-tier-3', 7500);
  var subTier3Label  = attrStr('subtotal-tier-3-label', 'Free Mystery Gift');
  var subTier4       = attrInt('subtotal-tier-4', 9900);
  var subTier4Label  = attrStr('subtotal-tier-4-label', 'Free Deluxe Gift Box');
  var subTier5       = attrInt('subtotal-tier-5', 0);
  var subTier5Label  = attrStr('subtotal-tier-5-label', '');
  var subTier6       = attrInt('subtotal-tier-6', 0);
  var subTier6Label  = attrStr('subtotal-tier-6-label', '');
  var countTier3     = attrInt('count-tier-3', 0);
  var countTier3Pct  = attrInt('count-tier-3-pct', 0);
  var countTier4     = attrInt('count-tier-4', 0);
  var countTier4Pct  = attrInt('count-tier-4-pct', 0);
  var countTier5     = attrInt('count-tier-5', 0);
  var countTier5Pct  = attrInt('count-tier-5-pct', 0);
  var popupTrigger   = attrInt('popup-trigger', 0);
  var maxFillPct     = attrInt('max-fill-pct', 95);

  // Tier gift info (auto-add at milestone)
  function makeGift(tierIdx) {
    var variant = attrInt('tier-' + tierIdx + '-gift-variant', 0);
    if (!variant) return null;
    return {
      tier: tierIdx,
      handle: attrStr('tier-' + tierIdx + '-gift-handle', ''),
      variantId: variant,
      title: attrStr('tier-' + tierIdx + '-gift-title', 'Free gift'),
      // Variant title (e.g., "Black", "18K Gold / Small"). Used by the Review
      // Your Bundle drawer to surface what colour/size the customer is
      // receiving for the free gift, matching the variant subtitle shown for
      // paid items. Will be empty or "Default Title" for single-variant gifts —
      // the render site handles that case by not rendering the subtitle row.
      variantTitle: attrStr('tier-' + tierIdx + '-gift-variant-title', ''),
      image: attrStr('tier-' + tierIdx + '-gift-image', ''),
      decorative: attrStr('tier-' + tierIdx + '-gift-decorative', 'false') === 'true'
    };
  }
  var tierGifts = [
    makeGift(1), makeGift(2), makeGift(3), makeGift(4), makeGift(5), makeGift(6)
  ];

  var subtotalTiers = [
    { id: 1, cents: subTier1, label: subTier1Label, gift: tierGifts[0] },
    { id: 2, cents: subTier2, label: subTier2Label, gift: tierGifts[1] },
    { id: 3, cents: subTier3, label: subTier3Label, gift: tierGifts[2] },
    { id: 4, cents: subTier4, label: subTier4Label, gift: tierGifts[3] },
    { id: 5, cents: subTier5, label: subTier5Label, gift: tierGifts[4] },
    { id: 6, cents: subTier6, label: subTier6Label, gift: tierGifts[5] }
  ];
  // Trim to active milestone count
  subtotalTiers = subtotalTiers.slice(0, milestoneCount);
  var maxTierCents = subtotalTiers[subtotalTiers.length - 1].cents;

  // ============ DOM REFS ============
  var cards     = section.querySelectorAll('.bab__card');
  var summary   = section.querySelector('#bab-summary');
  var thumbsEl  = section.querySelector('[data-bab-thumbs]');
  var countEl   = section.querySelector('[data-bab-count]');
  var totalEl   = section.querySelector('[data-bab-total]');
  var nextEl    = section.querySelector('[data-bab-next]');
  var addBtn    = section.querySelector('[data-bab-add-bundle]');
  var barCta    = section.querySelector('[data-bab-bar-cta]');
  var barPriceEl = section.querySelector('[data-bab-bar-price]');
  var tierFill  = section.querySelector('[data-tier-fill]');
  var tierHint  = section.querySelector('[data-tier-hint]');
  var tierHintInline = section.querySelector('[data-tier-hint-inline]');
  var tierCard  = section.querySelector('#bab-tiers');
  var countPills = section.querySelectorAll('.bab__tier-pill--count');
  var milestones = section.querySelectorAll('.bab__milestone');
  var gwpModal   = section.querySelector('#bab-gwp');
  var gwpBody    = section.querySelector('[data-bab-gwp-body]');
  var gwpCloseEls = section.querySelectorAll('[data-bab-gwp-close]');
  var popupModal = section.querySelector('#bab-popup');
  var popupCloseEls = popupModal ? popupModal.querySelectorAll('[data-bab-popup-close]') : [];
  var popupAddBtns = popupModal ? popupModal.querySelectorAll('[data-bab-popup-add]') : [];
  // F1 hardening: the set of variant IDs LEGITIMATELY offered as popup free gifts,
  // built from the server-rendered popup buttons. localStorage is shopper-controlled,
  // so this allowlist lets us refuse restoring/adding any arbitrary variant as a free
  // `_gift='upsell-free'` line. Defense-in-depth only — the authoritative gift-
  // eligibility check must live in the Shopify discount/Function rules (which must
  // never zero a line based on the client-supplied `_gift` property alone).
  var popupVariantAllowlist = (function() {
    var allow = {};
    Array.prototype.forEach.call(popupAddBtns, function(b) {
      var v = parseInt(b.getAttribute('data-variant-id'), 10);
      if (v) { allow[v] = true; }
    });
    return allow;
  })();
  var fakeCartModal = section.querySelector('#bab-fake-cart');
  var fakeCartCloseEls = fakeCartModal ? fakeCartModal.querySelectorAll('[data-bab-fake-cart-close]') : [];
  var fakeCartConfirm = fakeCartModal ? fakeCartModal.querySelector('[data-bab-fake-cart-confirm]') : null;
  var fakeCartList   = fakeCartModal ? fakeCartModal.querySelector('[data-bab-fake-cart-list]') : null;
  var fakeCartTiers  = fakeCartModal ? fakeCartModal.querySelector('[data-bab-fake-cart-tiers]') : null;
  var fakeCartTotal  = fakeCartModal ? fakeCartModal.querySelector('[data-bab-fake-cart-total]') : null;

  // Optional sticky top bar
  var topBar      = document.getElementById('bab-top-bar');
  var topBarFill  = topBar ? topBar.querySelector('[data-bab-top-fill]') : null;
  var topBarCount = topBar ? topBar.querySelector('[data-bab-top-count]') : null;
  var topBarNext  = topBar ? topBar.querySelector('[data-bab-top-next]') : null;

  // Selection state
  // - selected: Map<variantId, item> — user-picked products
  // - giftsActive: Map<tierIdx, gift>  — auto-added free gifts (kept separate so they don't count toward count tiers OR subtotal)
  var selected = new Map();
  var giftsActive = new Map();
  var topTierShown = false;
  var popupShown = false;
  var pendingCartAdd = false;

  // Forward reference — assigned inside initQuickView() so card click handlers
  // can open the modal directly for multi-option products (size, material, etc.).
  // If quick view never initialises (no modal in DOM) this stays a no-op.
  var openBabQuickView = function() {};

  // ============ ANALYTICS / ORDER ATTRIBUTION ============
  // One bundle session ID per page load — groups all line items added in this session
  // so reports can identify "which products were bundled together".
  var bundleSessionId = String(Date.now()) + '-' + Math.floor(Math.random() * 1000);
  // Source tag — used by Shopify Flow / reports to identify orders from this page
  var bundleSource = (section.dataset.bundleSource || 'custom-build-a-bundle');
  // Track add order so we can write _bundle_position per item
  var addCounter = 0;
  var itemAddOrder = new Map(); // variantId → position (0-indexed)

  // ============ HELPERS ============
  // Format an integer-cents value as a price string, matching the visual format
  // of the Liquid `| money` filter on this shop. ZUDO's store has the "strip
  // trailing zeros" money setting enabled, so Liquid renders $30 (not $30.00)
  // for whole-dollar prices. When JS later overwrites the price on swatch click
  // via refreshCardPrice(), the displayed string was switching from "$30" to
  // "$30.00" — visible inconsistency. We strip a trailing ".00" from the JS-
  // formatted string to match. Non-whole amounts (e.g. $19.99, $30.50) keep
  // their decimals.
  // Cart currency code stamped at Liquid time (e.g. "USD", "CAD", "GBP"). Used
  // by formatMoney(cents, true) to render multi-market-safe price strings like
  // "$94 USD" instead of just "$94" — eliminates the chargeback ambiguity for
  // Canadian / international shoppers who'd otherwise read $94 as USD and
  // dispute when their card gets charged in their local currency.
  var currencyCode = attrStr('cart-currency', 'USD');

  // formatMoney — Bug #1 fix: ZUDO's shop strips trailing .00 via the Liquid
  // `money` filter. The JS formatter mirrors that so a $30 product never
  // renders as $30.00 mid-flow when state changes. Optional second param
  // appends the ISO currency code (e.g. " USD") at price-commitment surfaces
  // (Add to Cart button, Review modal subtotal, line items, bottom-bar total).
  // The `.00(\s|$)` regex strips both `.00$` (legacy) AND `.00 USD` patterns.
  // F4: map the ISO code to its symbol so worldwide markets don't render the wrong
  // glyph (e.g. show "£94 GBP" not "$94 GBP"). USD/CAD/AUD/NZD/MXN all use "$", so
  // the common USD/CAD path is byte-for-byte unchanged — this only corrects the
  // non-dollar currencies that would otherwise display a misleading "$".
  function babCurrencySymbol(code) {
    switch (code) {
      case 'GBP': return '£';
      case 'EUR': return '€';
      case 'JPY': return '¥';
      case 'INR': return '₹';
      default:    return '$';
    }
  }
  function formatMoney(cents, includeCurrency) {
    var formatted = (Math.round(cents) / 100).toFixed(2);
    var withCurrency = babCurrencySymbol(currencyCode) + formatted + (includeCurrency ? ' ' + currencyCode : '');
    return withCurrency.replace(/\.00(\s|$)/, '$1');
  }

  function setRichText(el, parts) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    parts.forEach(function(p) {
      if (p.strong) {
        var s = document.createElement('strong');
        s.textContent = p.strong;
        el.appendChild(s);
      } else if (p.text) {
        el.appendChild(document.createTextNode(p.text));
      }
    });
  }

  function getCardState(card) {
    var activeSwatch = card.querySelector('.color-swatch.is-active');
    var price, image, variantId, compare, variantTitle;
    if (activeSwatch) {
      variantId    = parseInt(activeSwatch.dataset.variantId, 10);
      price        = parseInt(activeSwatch.dataset.variantPrice, 10);
      compare      = parseInt(activeSwatch.dataset.variantCompare, 10) || price;
      image        = activeSwatch.dataset.variantImage;
      variantTitle = activeSwatch.dataset.variantTitle || '';
    } else {
      variantId    = parseInt(card.dataset.defaultVariantId, 10);
      price        = parseInt(card.dataset.defaultPrice, 10);
      compare      = parseInt(card.dataset.defaultComparePrice, 10) || price;
      image        = card.dataset.defaultImage;
      variantTitle = card.dataset.defaultVariantTitle || '';
    }
    return {
      card: card,
      variantId: variantId,
      price: price,
      compare: compare,
      image: image,
      title: card.dataset.title,
      variantTitle: variantTitle,
      productHandle: card.dataset.productHandle || ''
    };
  }

  // ============ MULTI-OPTION HELPERS ============
  // Parses cached variant + option metadata emitted by the Liquid loop. Used by
  // the Quick View modal to render size/material pickers and find the matching
  // variant for a given option selection.
  function parseCardVariants(card) {
    try { return JSON.parse(card.dataset.variants || '[]'); } catch (e) { return []; }
  }
  function parseCardProductOptions(card) {
    try { return JSON.parse(card.dataset.productOptions || '[]'); } catch (e) { return []; }
  }
  function isMultiOptionCard(card) {
    return card && card.dataset.hasMultiOptions === 'true';
  }
  // Returns the variant whose options array matches the selectedOptions map
  // ({ optionName: value, ... }). Returns null if no match (e.g. the customer
  // hasn't picked every option yet, or this combination doesn't exist).
  function findVariantBySelection(card, selectedOptions) {
    var variants = parseCardVariants(card);
    var opts = parseCardProductOptions(card);
    if (!variants.length || !opts.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var matches = true;
      for (var j = 0; j < opts.length; j++) {
        var optName = opts[j].name;
        var picked = selectedOptions[optName];
        if (picked == null) { matches = false; break; }
        if (v.options[j] !== picked) { matches = false; break; }
      }
      if (matches) return v;
    }
    return null;
  }
  // Returns true if ANY variant of this card's product is in the bundle. Used
  // to drive the "Added ✓" visual state on multi-option cards.
  function isProductInBundle(card) {
    var handle = card.dataset.productHandle || '';
    if (!handle) return false;
    var found = false;
    selected.forEach(function(item) {
      if (item.productHandle === handle && !item.fromPopup) found = true;
    });
    return found;
  }
  // Update visual + CTA state of multi-option cards in response to bundle
  // changes (e.g. user removed an item via the Review modal). Called from
  // updateSummary so every state transition keeps cards in sync.
  function syncMultiOptionCardStates() {
    var allCards = section.querySelectorAll('.bab__card--multi-options');
    allCards.forEach(function(c) {
      var inBundle = isProductInBundle(c);
      c.classList.toggle('is-selected', inBundle);
      var addEl = c.querySelector('.bab__card-cta-add');
      if (addEl) {
        var addedCount = 0;
        var handle = c.dataset.productHandle;
        selected.forEach(function(item) {
          if (item.productHandle === handle && !item.fromPopup) addedCount++;
        });
        // Default CTA reads from data-multi-option-cta-text; we don't overwrite
        // the .bab__card-cta-added element which already shows "Added ✓" via
        // CSS swap when .is-selected is on the card.
        if (!inBundle) addEl.textContent = c.dataset.multiOptionCtaText || 'Choose Size';
      }
    });
  }

  function refreshCardPrice(card) {
    var state = getCardState(card);
    var priceEl = card.querySelector('[data-bab-price]');
    var compareEl = card.querySelector('[data-bab-compare]');
    var imageEl = card.querySelector('[data-bab-image]');
    if (priceEl) priceEl.textContent = formatMoney(state.price);
    if (compareEl && state.compare > state.price) compareEl.textContent = formatMoney(state.compare);
    if (imageEl && state.image) imageEl.src = state.image;
  }

  function renderThumbs() {
    while (thumbsEl.firstChild) thumbsEl.removeChild(thumbsEl.firstChild);
    var totalCount = selected.size + giftsActive.size;
    if (totalCount === 0) return;

    var list = Array.from(selected.values()).slice(0, 3);
    list.forEach(function(item) {
      var wrap = document.createElement('div');
      wrap.className = 'bab__summary-thumb-wrap';
      var img = document.createElement('img');
      img.className = 'bab__summary-thumb';
      img.src = item.image;
      img.alt = item.title;
      wrap.appendChild(img);
      thumbsEl.appendChild(wrap);
    });

    // Show one gift thumb if any are active
    if (giftsActive.size > 0) {
      var firstGift = giftsActive.values().next().value;
      var wrap = document.createElement('div');
      wrap.className = 'bab__summary-thumb-wrap is-gift';
      var img = document.createElement('img');
      img.className = 'bab__summary-thumb';
      img.src = firstGift.image;
      img.alt = firstGift.title;
      wrap.appendChild(img);
      var badge = document.createElement('span');
      badge.className = 'bab__summary-thumb-badge';
      badge.textContent = 'FREE';
      wrap.appendChild(badge);
      thumbsEl.appendChild(wrap);
    }

    var overflow = (selected.size > 3 ? selected.size - 3 : 0) + (giftsActive.size > 1 ? giftsActive.size - 1 : 0);
    if (overflow > 0) {
      var more = document.createElement('span');
      more.className = 'bab__summary-thumb-more';
      more.textContent = '+' + overflow;
      thumbsEl.appendChild(more);
    }
  }

  // ============ AUTO-ADD GIFTS AT MILESTONES ============
  function syncGifts(subtotal) {
    // For each tier with a gift configured, add if unlocked, remove if not
    subtotalTiers.forEach(function(t) {
      if (!t.gift) return;
      var shouldHaveGift = subtotal >= t.cents;
      var currentlyHas = giftsActive.has(t.id);
      if (shouldHaveGift && !currentlyHas) {
        giftsActive.set(t.id, t.gift);
      } else if (!shouldHaveGift && currentlyHas) {
        giftsActive.delete(t.id);
      }
    });
  }

  // ============ F1: LOCALSTORAGE PERSISTENCE ============
  // Persists `selected` to localStorage so the shopper's bundle survives reloads,
  // tab restoration, and accidental nav-aways. We only serialize fields that
  // restore cleanly (no DOM refs). On restore we re-validate every variantId
  // against the current card pool — variants may have been removed since the
  // shopper last visited, and silently re-adding a phantom variant would break
  // cart-add.
  //
  // Storage key is versioned so we can ship breaking changes by bumping it.
  // TTL: 7 days. Stale 2-week-old bundles confuse more than they help.
  var STORAGE_KEY = 'bab.selected.v1';
  var STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  function persistSelection() {
    try {
      var items = [];
      selected.forEach(function(item) {
        // `card` is a DOM ref — recompute on restore. Everything else serializes.
        items.push({
          variantId: item.variantId,
          price: item.price,
          compare: item.compare,
          image: item.image,
          title: item.title,
          variantTitle: item.variantTitle || '',
          // productHandle is REQUIRED for multi-option cards: syncMultiOptionCardStates()
          // matches selected items to their card by productHandle to keep the "Added ✓"
          // state + .is-selected highlight in sync. Without persisting it, a restored
          // multi-option product stays in the bundle but its card reverts to "Choose Size".
          productHandle: item.productHandle || '',
          fromPopup: !!item.fromPopup
        });
      });
      if (items.length === 0) {
        // Empty bundle = wipe the key entirely. Avoids loading empty arrays on next visit.
        localStorage.removeItem(STORAGE_KEY);
        return;
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: 1,
        ts: Date.now(),
        items: items
      }));
    } catch (e) { /* private mode / quota / disabled — silent best-effort */ }
  }
  function restoreSelection() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return 0;
      var payload = JSON.parse(raw);
      if (!payload || payload.version !== 1) {
        localStorage.removeItem(STORAGE_KEY);
        return 0;
      }
      if (Date.now() - (payload.ts || 0) > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return 0;
      }
      var restored = 0;
      (payload.items || []).forEach(function(it) {
        if (!it || !it.variantId) return;
        // Validate the variant still exists in the current card pool. We check
        // BOTH the default-variant-id (card-level) and the full variant-data
        // array (variant-level) so multi-option products are honored.
        var match = null;
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          if (parseInt(c.dataset.defaultVariantId, 10) === it.variantId) { match = c; break; }
          try {
            var vd = JSON.parse(c.dataset.variants || '[]');
            for (var j = 0; j < vd.length; j++) {
              if (vd[j].id === it.variantId) { match = c; break; }
            }
            if (match) break;
          } catch (e) {}
        }
        // Popup-sourced items don't need a card match — they exist in the
        // gift-selection popup, not the grid. But localStorage is shopper-controlled,
        // so a fromPopup item is only honored when its variant is still a currently-
        // offered popup gift (F1 hardening); otherwise we silently drop it.
        if (it.fromPopup && !popupVariantAllowlist[it.variantId]) return;
        if (!match && !it.fromPopup) return;

        selected.set(it.variantId, {
          variantId: it.variantId,
          price: it.price,
          compare: it.compare,
          image: it.image,
          title: it.title,
          variantTitle: it.variantTitle || '',
          // Restore productHandle so syncMultiOptionCardStates() can re-link the
          // item to its card (keeps "Added ✓" + .is-selected). Fall back to the
          // matched card's handle for older persisted payloads that predate this field.
          productHandle: it.productHandle || (match ? match.dataset.productHandle : ''),
          card: match,
          fromPopup: !!it.fromPopup
        });
        itemAddOrder.set(it.variantId, addCounter++);
        if (match) match.classList.add('is-selected');
        restored++;
      });
      return restored;
    } catch (e) { return 0; }
  }

  // ============ UI UPDATE ============
  function updateSummary() {
    var count = selected.size;
    var subtotal = 0;
    selected.forEach(function(item) { if (!item.fromPopup) subtotal += item.price; });

    // Auto-add / remove gifts based on subtotal crossing tier thresholds
    syncGifts(subtotal);

    countEl.textContent = count + ' item' + (count === 1 ? '' : 's');
    // Commitment surface — show currency code so Canadian / international
    // shoppers don't mistake CAD/AUD/etc. for USD at the moment of purchase.
    totalEl.textContent = count > 0 ? formatMoney(subtotal, true) : '';

    // Count-tier pills. Each tier now requires `> 0` to engage so the merchant
    // can disable any tier by setting its threshold to 0 in the customizer
    // (matches the Tier 3/4/5 pattern; previously Tier 1/2 ignored the disable).
    countPills.forEach(function(p) {
      var tier = p.dataset.tier;
      if ((tier === 'count-1' && countTier1 > 0 && count >= countTier1) ||
          (tier === 'count-2' && countTier2 > 0 && count >= countTier2) ||
          (tier === 'count-3' && countTier3 > 0 && count >= countTier3) ||
          (tier === 'count-4' && countTier4 > 0 && count >= countTier4) ||
          (tier === 'count-5' && countTier5 > 0 && count >= countTier5)) {
        p.classList.add('is-unlocked');
      } else {
        p.classList.remove('is-unlocked');
      }
    });

    // Subtotal milestones
    var unlockedTier = null;
    var nextTier = null;
    subtotalTiers.forEach(function(t, i) {
      var milestone = milestones[i];
      if (!milestone) return;
      if (subtotal >= t.cents) {
        milestone.classList.add('is-unlocked');
        unlockedTier = t;
      } else {
        milestone.classList.remove('is-unlocked');
        if (!nextTier) nextTier = t;
      }
    });

    // Raw progress (0-100) is then scaled to maxFillPct so the visual fill stops
    // at the last milestone's inset position rather than overflowing past it.
    var rawPct = Math.min(100, (subtotal / maxTierCents) * 100);
    var pct = (rawPct / 100) * maxFillPct;
    if (tierFill) tierFill.style.width = pct + '%';
    if (topBarFill) topBarFill.style.width = rawPct + '%';
    // Toggle the "all unlocked" glow on the tier card when every milestone is hit
    if (tierCard) {
      if (subtotal >= maxTierCents) tierCard.classList.add('is-all-unlocked');
      else tierCard.classList.remove('is-all-unlocked');
    }

    // Tier hint text — updates both the external hint AND the inline bar hint.
    // Copy uses IMPERATIVE framing ("Add $X to unlock your Y") instead of the
    // weaker declarative ("Spend $X more to unlock Y"). Three psychology shifts:
    //   1. "Add" is a softer, action-direct verb vs "Spend" (which signals cost).
    //   2. Removed "more" — the strikethrough delta is already visible in the
    //      progress bar; the word adds friction without information.
    //   3. Inserted possessive "your" before the gift label — endowment-effect
    //      framing (Liquid I.V., Care/of all use this pattern in their hint copy).
    // Count only PAID products (exclude auto gifts in giftsActive + the $150 popup
    // pick via fromPopup). Used by the merged hint nudge below AND the footer CTA.
    var paidCount = 0;
    selected.forEach(function(item) { if (!item.fromPopup) paidCount++; });

    var hintParts;
    if (count === 0) {
      hintParts = fillQtyTemplate(textProgressEmpty, {});
    } else {
      // Dollar gift-ladder part ("Add $X to unlock your Y").
      var dollarParts;
      if (nextTier) {
        dollarParts = fillQtyTemplate(textProgressUnlock, { amount: formatMoney(nextTier.cents - subtotal), reward: nextTier.label });
      } else {
        dollarParts = fillQtyTemplate(textAllUnlocked, {});
      }
      // Item-count "Buy N, get the next free" nudge, merged into the SAME hint line
      // (no separate banner). Display only; the discount is a Shopify automatic one.
      // paidCount already excludes the gift box / mystery gift / $150 popup pick.
      // "Buy N, get the next free" REPEATS (Shopify BxGy "BUY 2 GET 3RD FREE" has no
      // per-order limit), so a customer past a multiple of (N+1) has ALREADY earned
      // free item(s). Surface that ("🎉 1 piece FREE!") together with the items-to-next,
      // so the message never looks like it's ignoring what they've already earned.
      // (Discount applies at checkout; the "Discount applied at checkout" line is below.)
      if (qtyOfferOn && paidCount > 0) {
        var grp = qtyBuyN + 1;
        var into = paidCount % grp;
        var earned = Math.floor(paidCount / grp);
        var toNext = into === 0 ? grp : (grp - into);
        var qNums = { n: toNext, earned: earned, buyn: qtyBuyN, word: qtyWord };
        var qParts = fillQtyTemplate(earned === 0 ? qtyMsgProgress : qtyMsgEarned, qNums);
        hintParts = qParts.concat([{ text: '  ·  ' }], dollarParts);
      } else {
        hintParts = dollarParts;
      }
    }
    setRichText(tierHint, hintParts);
    setRichText(tierHintInline, hintParts);

    // Footer next-tier hint
    if (count > 0 && nextTier) {
      var remaining2 = nextTier.cents - subtotal;
      setRichText(nextEl, [
        { text: formatMoney(remaining2) + ' to ' },
        { strong: nextTier.label }
      ]);
    } else if (count > 0 && unlockedTier && unlockedTier.id === milestoneCount) {
      setRichText(nextEl, fillQtyTemplate(textAllUnlocked, {}));
    } else {
      nextEl.textContent = '';
    }

    // Top bar mirrors footer hint
    if (topBarCount) topBarCount.textContent = count + ' item' + (count === 1 ? '' : 's');
    if (topBarNext) {
      if (count === 0) {
        topBarNext.textContent = textProgressEmpty.replace(/\*\*/g, '');
      } else if (nextTier) {
        setRichText(topBarNext, [
          { text: formatMoney(nextTier.cents - subtotal) + ' to ' },
          { strong: nextTier.label }
        ]);
      } else {
        topBarNext.textContent = textAllUnlocked.replace(/\*\*/g, '');
      }
    }

    renderThumbs();

    // Keep multi-option card states in sync — their "Added ✓" depends on
    // whether ANY variant of the product is in the bundle (tracked by
    // productHandle), not on a single variantId like color-only cards.
    syncMultiOptionCardStates();

    // CTA state — sticky footer. paidCount was computed above (with the tier hint).

    countEl.textContent = paidCount + ' item' + (paidCount === 1 ? '' : 's');
    if (paidCount >= minItems) {
      addBtn.disabled = false;
      var defaultLabel = addBtn.querySelector('.bab__summary-cta-default');
      if (defaultLabel) defaultLabel.textContent = fakeCartPreview ? textReviewTitle.replace(/\*\*/g, '') : 'Add to Cart';
      var freeCount = giftsActive.size + (count - paidCount);
      var freeMsg = freeCount > 0 ? '+ ' + freeCount + ' free gift' + (freeCount === 1 ? '' : 's') : '';
      countEl.textContent = paidCount + ' item' + (paidCount === 1 ? '' : 's') + (freeMsg ? ' ' + freeMsg : '');
    } else {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-state');
      var defaultLabel2 = addBtn.querySelector('.bab__summary-cta-default');
      var needed = Math.max(0, minItems - paidCount);
      if (defaultLabel2) defaultLabel2.textContent = needed > 0 ? 'Add ' + needed + ' more' : 'Add to Cart';
      countEl.textContent = paidCount > 0 ? paidCount + ' item' + (paidCount === 1 ? '' : 's') : '0 items';
    }

    // CTA state — in-bar CTA (mirrors the sticky footer button)
    if (barCta) {
      barCta.disabled = paidCount < minItems;
    }
    if (barPriceEl) {
      // Floating bar / Add to Cart price — commitment surface, currency on.
      // Empty-bundle state routes through formatMoney(0, true) so the
      // trailing-zero strip is consistent with all other prices on the page.
      barPriceEl.textContent = count > 0 ? formatMoney(subtotal, true) : formatMoney(0, true);
    }

    // Visibility
    if (count > 0) summary.classList.add('is-visible');
    else summary.classList.remove('is-visible');

    // GWP celebration modal — only fires when top tier is crossed
    if (unlockedTier && unlockedTier.id === milestoneCount && !topTierShown) {
      topTierShown = true;
      openGwp(unlockedTier.label);
    }
    if (!unlockedTier || unlockedTier.id < milestoneCount) topTierShown = false;

    // Curated upsell popup — re-triggers each time the threshold is crossed
    if (popupModal && popupTrigger > 0) {
      var atTrigger = unlockedTier && unlockedTier.id >= popupTrigger;
      if (atTrigger && !popupShown) {
        popupShown = true;
        var popupDelay = unlockedTier.id === milestoneCount ? 2200 : 600;
        function tryOpenPopup() {
          if (gwpModal && gwpModal.classList.contains('is-open')) {
            setTimeout(tryOpenPopup, 500);
            return;
          }
          openPopup();
        }
        setTimeout(tryOpenPopup, popupDelay);
      }
      if (!atTrigger && popupShown) {
        popupShown = false;
        // Remove previous upsell free pick so they can re-select
        selected.forEach(function(item, key) {
          if (item.fromPopup) selected.delete(key);
        });
      }
    }

    // GTM/dataLayer
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'zudo_bundle_state_change',
        bundle_count: count,
        bundle_subtotal_cents: subtotal,
        unlocked_tier: unlockedTier ? unlockedTier.id : 0,
        market: market,
        gifts_active: Array.from(giftsActive.values()).map(function(g) { return g.handle; })
      });
    } catch (e) {}

    // F1: Persist after every state change. Runs at end of updateSummary so
    // any gift auto-add/remove from syncGifts() is captured too.
    persistSelection();
  }

  function toggleCard(card) {
    var state = getCardState(card);
    if (selected.has(state.variantId)) {
      selected.delete(state.variantId);
      itemAddOrder.delete(state.variantId);
      card.classList.remove('is-selected');
    } else {
      // Record the order this item was added (for _bundle_position line item property)
      itemAddOrder.set(state.variantId, addCounter++);
      selected.set(state.variantId, state);
      card.classList.add('is-selected');
    }
    updateSummary();
  }

  // ============ MODAL HELPERS (a11y-safe open/close) ============
  // Blur any focused descendant before setting aria-hidden=true to avoid the
  // "Blocked aria-hidden on an element because its descendant retained focus"
  // browser warning. Restore body scroll on close.
  //
  // FOCUS MANAGEMENT (dialog a11y): on open we remember the opener, move focus
  // into the dialog and trap Tab / Shift+Tab inside it; on close we restore
  // focus to the opener. A stack supports nested layers (the size guide opens
  // on top of the Quick View). The single Tab handler below acts ONLY while a
  // bundle dialog is open, so it never affects normal page tabbing or the
  // filter-tab arrow-key navigation.
  var babFocusStack = [];
  function babGetFocusable(container) {
    if (!container) return [];
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(sel), function(el) {
      // Skip controls inside a size guide overlay that is currently closed — it
      // stays in the DOM at opacity:0 so its buttons would otherwise stay tabbable.
      var sg = el.closest ? el.closest('.bab__qv-size-guide') : null;
      if (sg && !sg.classList.contains('is-open')) return false;
      // Skip anything inside an aria-hidden subtree nested in this dialog.
      var hidden = el.closest ? el.closest('[aria-hidden="true"]') : null;
      if (hidden && hidden !== container && container.contains(hidden)) return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }
  function babActivateFocusTrap(modalEl) {
    if (!modalEl) return;
    babFocusStack.push({ modal: modalEl, prevFocus: document.activeElement });
    // Defer so display / layout settle before moving focus in.
    setTimeout(function() {
      if (!modalEl.classList.contains('is-open')) return;
      var f = babGetFocusable(modalEl);
      if (f.length) {
        try { f[0].focus(); } catch (e) {}
      } else {
        if (!modalEl.hasAttribute('tabindex')) modalEl.setAttribute('tabindex', '-1');
        try { modalEl.focus(); } catch (e) {}
      }
    }, 30);
  }
  function babReleaseFocusTrap(modalEl) {
    if (!modalEl) return;
    var idx = -1;
    for (var i = babFocusStack.length - 1; i >= 0; i--) {
      if (babFocusStack[i].modal === modalEl) { idx = i; break; }
    }
    if (idx === -1) return;
    // Remove this layer plus any nested layers stacked above it, then restore
    // focus to THIS layer's opener (the outermost one being closed).
    var removed = babFocusStack.splice(idx);
    var prev = removed[0] && removed[0].prevFocus;
    if (prev && typeof prev.focus === 'function' && document.contains(prev)) {
      // Defer one tick so the restore runs AFTER any other synchronous
      // keydown/close handlers (e.g. the theme's global Escape handler, which
      // fires on real key presses) have finished — otherwise they can steal
      // focus back to <body> right after we set it.
      setTimeout(function() {
        if (prev && document.contains(prev)) { try { prev.focus(); } catch (e) {} }
      }, 0);
    }
  }
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab' || babFocusStack.length === 0) return;
    var top = babFocusStack[babFocusStack.length - 1].modal;
    if (!top || !top.classList.contains('is-open')) return;
    var f = babGetFocusable(top);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    var active = document.activeElement;
    if (!top.contains(active)) {
      e.preventDefault();
      try { first.focus(); } catch (err) {}
      return;
    }
    if (e.shiftKey && active === first) {
      e.preventDefault();
      try { last.focus(); } catch (err) {}
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      try { first.focus(); } catch (err) {}
    }
  }, true);

  function safeCloseModal(modalEl) {
    if (!modalEl) return;
    var focused = modalEl.contains(document.activeElement) ? document.activeElement : null;
    if (focused && typeof focused.blur === 'function') focused.blur();
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.removeAttribute('aria-modal');
    document.body.style.overflow = '';
    babReleaseFocusTrap(modalEl);
  }
  function safeOpenModal(modalEl) {
    if (!modalEl) return;
    modalEl.classList.add('is-open');
    modalEl.setAttribute('aria-hidden', 'false');
    if (!modalEl.getAttribute('role')) modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    document.body.style.overflow = 'hidden';
    babActivateFocusTrap(modalEl);
  }

  // ============ GWP MODAL ============
  function openGwp(label) {
    if (!gwpModal) return;
    gwpBody.textContent = label + ' is included with your bundle. Free of charge.';
    safeOpenModal(gwpModal);
  }
  function closeGwp() { safeCloseModal(gwpModal); }

  // ============ CURATED UPSELL POPUP ============
  function openPopup() {
    if (!popupModal) return;
    // Re-enable all popup add buttons (they get disabled after single-select)
    popupAddBtns.forEach(function(btn) { btn.disabled = false; });
    popupModal.querySelectorAll('.bab__popup-product.is-added').forEach(function(p) { p.classList.remove('is-added'); });
    safeOpenModal(popupModal);
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'zudo_bundle_upsell_popup_shown',
        market: market
      });
    } catch (e) {}
  }
  function closePopup() { safeCloseModal(popupModal); }

  popupAddBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId || selected.has(variantId)) return;
      var item = {
        variantId: variantId,
        price: parseInt(btn.dataset.price, 10) || 0,
        compare: parseInt(btn.dataset.price, 10) || 0,
        image: btn.dataset.image,
        title: btn.dataset.title,
        // Carry the variant title through so the Review Your Bundle drawer can
        // render its variant subtitle row (matching paid items + milestone
        // gifts). Skipped silently by appendVariantSubtitle() if blank or the
        // Shopify "Default Title" single-variant placeholder.
        variantTitle: btn.dataset.variantTitle || '',
        card: null,
        fromPopup: true
      };
      itemAddOrder.set(variantId, addCounter++);
      selected.set(variantId, item);
      btn.closest('.bab__popup-product').classList.add('is-added');

      // Disable all other add buttons — single selection only
      popupAddBtns.forEach(function(otherBtn) { otherBtn.disabled = true; });

      updateSummary();

      // Reflect in grid if the upsell exists in the visible grid too
      cards.forEach(function(c) {
        var defId = parseInt(c.dataset.defaultVariantId, 10);
        if (defId === variantId) c.classList.add('is-selected');
      });

      // Auto-close popup after brief delay
      setTimeout(function() { closePopup(); }, 600);

      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'zudo_bundle_upsell_added',
          variant_id: variantId,
          market: market
        });
      } catch (e) {}
    });
  });

  // ============ FAKE CART PREVIEW ============
  function buildFakeCart() {
    if (!fakeCartModal || !fakeCartList) return;

    while (fakeCartList.firstChild) fakeCartList.removeChild(fakeCartList.firstChild);
    var subtotal = 0;

    // Helper — append a variant-title subtitle row to a line body if the
    // product has a real variant (i.e., not Shopify's "Default Title"
    // single-variant placeholder). Mirrors the same pattern used for paid
    // items further down so free-gift rows look visually consistent with
    // paid rows ("18K Gold", "Black", "18K Gold / 1mm Cable Chain", etc.).
    function appendVariantSubtitle(body, variantTitle) {
      if (!variantTitle) return;
      if (variantTitle.toLowerCase() === 'default title') return;
      var variant = document.createElement('p');
      variant.className = 'bab__fake-cart-line-variant';
      variant.textContent = variantTitle;
      body.appendChild(variant);
    }

    // Free gifts — rendered FIRST so they appear at top
    giftsActive.forEach(function(gift) {
      var line = document.createElement('div');
      line.className = 'bab__fake-cart-line is-gift';
      var img = document.createElement('img');
      img.className = 'bab__fake-cart-line-img';
      img.src = gift.image; img.alt = gift.title;
      var body = document.createElement('div');
      body.className = 'bab__fake-cart-line-body';
      var title = document.createElement('p');
      title.className = 'bab__fake-cart-line-title';
      title.textContent = gift.title;
      body.appendChild(title);
      appendVariantSubtitle(body, gift.variantTitle);
      var priceWrap = document.createElement('div');
      var free = document.createElement('span');
      free.className = 'bab__fake-cart-line-free';
      free.textContent = 'FREE';
      priceWrap.appendChild(free);
      body.appendChild(priceWrap);
      line.appendChild(img); line.appendChild(body);
      fakeCartList.appendChild(line);
    });

    // Upsell popup free items — render as FREE, grouped with gifts at top
    selected.forEach(function(item) {
      if (!item.fromPopup) return;
      var line = document.createElement('div');
      line.className = 'bab__fake-cart-line is-gift';
      var img = document.createElement('img');
      img.className = 'bab__fake-cart-line-img';
      img.src = item.image; img.alt = item.title;
      var body = document.createElement('div');
      body.className = 'bab__fake-cart-line-body';
      var title = document.createElement('p');
      title.className = 'bab__fake-cart-line-title';
      title.textContent = item.title;
      body.appendChild(title);
      appendVariantSubtitle(body, item.variantTitle);
      var free = document.createElement('span');
      free.className = 'bab__fake-cart-line-free';
      free.textContent = 'FREE';
      body.appendChild(free);
      line.appendChild(img); line.appendChild(body);
      fakeCartList.appendChild(line);
    });

    // Paid items (exclude popup free items)
    selected.forEach(function(item) {
      if (item.fromPopup) return;
      subtotal += item.price;
      var line = document.createElement('div');
      line.className = 'bab__fake-cart-line';
      var img = document.createElement('img');
      img.className = 'bab__fake-cart-line-img';
      img.src = item.image; img.alt = item.title;
      var body = document.createElement('div');
      body.className = 'bab__fake-cart-line-body';
      var title = document.createElement('p');
      title.className = 'bab__fake-cart-line-title';
      title.textContent = item.title;
      body.appendChild(title);
      // Variant subtitle (e.g., "18K Gold / Small") — only show if variant title isn't "Default Title"
      if (item.variantTitle && item.variantTitle.toLowerCase() !== 'default title') {
        var variant = document.createElement('p');
        variant.className = 'bab__fake-cart-line-variant';
        variant.textContent = item.variantTitle;
        body.appendChild(variant);
      }
      var price = document.createElement('span');
      price.className = 'bab__fake-cart-line-price';
      price.textContent = formatMoney(item.price, true); // L1: include currency code
      body.appendChild(price);
      if (item.compare && item.compare > item.price) {
        var compareSpan = document.createElement('span');
        compareSpan.className = 'bab__fake-cart-line-compare';
        compareSpan.textContent = formatMoney(item.compare, true); // L1: include currency code
        body.appendChild(compareSpan);
      }
      line.appendChild(img); line.appendChild(body);

      // Remove button
      var removeBtn = document.createElement('button');
      removeBtn.className = 'bab__fake-cart-line-remove';
      removeBtn.textContent = '\u00d7';
      removeBtn.setAttribute('aria-label', 'Remove ' + item.title);
      (function(capturedItem) {
        removeBtn.addEventListener('click', function() {
          selected.delete(capturedItem.variantId);
          cards.forEach(function(c) {
            if (parseInt(c.dataset.defaultVariantId, 10) === capturedItem.variantId) c.classList.remove('is-selected');
          });
          updateSummary();
          buildFakeCart();
          if (selected.size === 0) closeFakeCart();
        });
      })(item);
      line.appendChild(removeBtn);

      fakeCartList.appendChild(line);
    });

    // Tier list
    if (fakeCartTiers) {
      while (fakeCartTiers.firstChild) fakeCartTiers.removeChild(fakeCartTiers.firstChild);
      // Count tiers — show only the HIGHEST applicable tier whose threshold
      // is > 0 (treat 0 as "this tier is disabled by the merchant"). Previously
      // only Tier 1 and Tier 2 were shown here; now we check all 5 tiers and
      // pick the best one. Iteration order assumes the merchant configures
      // thresholds + percents in ascending order — break on first match.
      var count = selected.size;
      var countTierConfigs = [
        { threshold: countTier5, percent: countTier5Pct },
        { threshold: countTier4, percent: countTier4Pct },
        { threshold: countTier3, percent: countTier3Pct },
        { threshold: countTier2, percent: countTier2Pct },
        { threshold: countTier1, percent: countTier1Pct }
      ];
      for (var ti = 0; ti < countTierConfigs.length; ti++) {
        var ct = countTierConfigs[ti];
        if (ct.threshold > 0 && count >= ct.threshold) {
          var el = document.createElement('div');
          el.className = 'bab__fake-cart-tier';
          el.textContent = ct.percent + '% off applied at checkout';
          fakeCartTiers.appendChild(el);
          break;
        }
      }
      // "Buy N, Get the next Free" — clarify the auto-discount applies AT CHECKOUT.
      // We don't mark a specific line "free" because Shopify picks the cheapest
      // eligible item at checkout, not here. Shown once the customer has earned >=1.
      if (qtyOfferOn) {
        var fcPaid = 0;
        selected.forEach(function(i){ if (!i.fromPopup) fcPaid++; });
        var fcEarned = Math.floor(fcPaid / (qtyBuyN + 1));
        if (fcEarned > 0) {
          var bogoEl = document.createElement('div');
          bogoEl.className = 'bab__fake-cart-tier bab__fake-cart-tier--bogo';
          // Wrap the message in ONE span so the row's flex `gap` only sits between
          // the 🎁 icon and the text — not between each text/bold chunk (which made
          // the words look spaced out).
          var bogoText = document.createElement('span');
          setRichText(bogoText, fillQtyTemplate(qtyMsgModal, { n: qtyBuyN + 1, earned: fcEarned, buyn: qtyBuyN, word: qtyWord }));
          bogoEl.appendChild(bogoText);
          fakeCartTiers.appendChild(bogoEl);
        }
      }
      // Subtotal tiers
      subtotalTiers.forEach(function(st) {
        if (subtotal >= st.cents) {
          var el = document.createElement('div');
          el.className = 'bab__fake-cart-tier';
          el.textContent = st.label + ' ' + textUnlockedSuffix;
          fakeCartTiers.appendChild(el);
        }
      });
    }

    if (fakeCartTotal) {
      // Review Your Bundle modal subtotal — final commitment review before checkout
      fakeCartTotal.textContent = formatMoney(subtotal, true);
      var compareTotal = 0;
      selected.forEach(function(item) {
        if (item.fromPopup) {
          compareTotal += item.compare || item.price;
        } else if (item.compare) {
          compareTotal += item.compare;
        }
      });
      var existingCompare = fakeCartTotal.parentNode.querySelector('.bab__fake-cart-totals-compare');
      if (compareTotal > subtotal) {
        if (!existingCompare) {
          existingCompare = document.createElement('span');
          existingCompare.className = 'bab__fake-cart-totals-compare';
          fakeCartTotal.parentNode.appendChild(existingCompare);
        }
        // Match currency code on the strikethrough total — matches the
        // primary subtotal so both numbers share their unit clearly.
        existingCompare.textContent = formatMoney(compareTotal, true);
      } else if (existingCompare) {
        existingCompare.remove();
      }
    }
  }

  function openFakeCart() {
    if (!fakeCartModal) return;
    buildFakeCart();
    safeOpenModal(fakeCartModal);
  }
  function closeFakeCart() { safeCloseModal(fakeCartModal); }

  // ============ EVENTS ============
  cards.forEach(function(card) {
    var multiOption = isMultiOptionCard(card);
    var swatches = card.querySelectorAll('.color-swatch');
    swatches.forEach(function(sw) {
      sw.addEventListener('click', function(e) {
        e.stopPropagation();
        // For color-only products the disabled state means "all variants of
        // this colour are OOS" (since one swatch maps to one variant). For
        // multi-option products the swatch's "first variant of this colour"
        // may be OOS while other sizes are in stock — so we still let the
        // click through and rely on the modal to surface actual availability.
        if (sw.classList.contains('is-disabled') && !multiOption) return;
        swatches.forEach(function(other) { other.classList.remove('is-active'); });
        sw.classList.add('is-active');
        refreshCardPrice(card);

        // Multi-option cards: the swatch is preview-only. The customer still has
        // to choose Size/Material in the modal, so we keep the card CTA as
        // "Choose Size" and skip the toggle-state logic below.
        if (multiOption) return;

        var isAvail = sw.getAttribute('data-available') === 'true';
        var ctaBtn = card.querySelector('[data-bab-toggle]');
        var ctaAddEl = ctaBtn ? ctaBtn.querySelector('.bab__card-cta-add') : null;
        var newVariantId = parseInt(sw.dataset.variantId, 10);
        var variantAlreadySelected = selected.has(newVariantId);
        if (ctaBtn && ctaAddEl) {
          if (!isAvail) {
            ctaBtn.disabled = true;
            ctaBtn.classList.add('bab__card-cta--oos');
            ctaAddEl.textContent = 'Out of Stock';
            card.classList.remove('is-selected');
          } else if (variantAlreadySelected) {
            ctaBtn.disabled = false;
            ctaBtn.classList.remove('bab__card-cta--oos');
            card.classList.add('is-selected');
          } else {
            ctaBtn.disabled = false;
            ctaBtn.classList.remove('bab__card-cta--oos');
            ctaAddEl.textContent = 'Add to Bundle';
            card.classList.remove('is-selected');
          }
        }
      });
    });

    var cta = card.querySelector('[data-bab-toggle]');
    var quickBtn = card.querySelector('.bab__card-quick');
    if (cta) {
      cta.addEventListener('click', function(e) {
        e.stopPropagation();
        // Multi-option products always go through the modal so the customer
        // can pick Size/Material before adding. The modal exposes a Remove
        // CTA when the currently selected variant is already in the bundle.
        if (multiOption) {
          openBabQuickView(card);
          return;
        }
        toggleCard(card);
      });
    }
    var imageWrap = card.querySelector('.bab__card-image-wrap');
    if (imageWrap) {
      imageWrap.addEventListener('click', function(e) {
        // Robust: any click that originated inside the (+) button OR any other interactive
        // element should NOT toggle the bundle. closest() walks up from e.target so it
        // handles clicks on nested children (svgs, spans) too.
        if (e.target.closest('.bab__card-quick') || e.target.closest('button[type="button"]:not([data-bab-toggle])') || e.target.closest('a')) return;
        if (multiOption) {
          openBabQuickView(card);
          return;
        }
        toggleCard(card);
      });
    }
  });

  gwpCloseEls.forEach(function(el) { el.addEventListener('click', closeGwp); });
  popupCloseEls.forEach(function(el) { el.addEventListener('click', closePopup); });
  fakeCartCloseEls.forEach(function(el) { el.addEventListener('click', function() {
    if (pendingCartAdd) return;
    closeFakeCart();
  }); });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (gwpModal && gwpModal.classList.contains('is-open')) closeGwp();
    if (popupModal && popupModal.classList.contains('is-open')) closePopup();
    if (fakeCartModal && fakeCartModal.classList.contains('is-open') && !pendingCartAdd) closeFakeCart();
  });

  // ============ STICKY TIER CARD ============
  // Two responsibilities, both driven by scroll position:
  //   1) .is-stuck on tierCard — toggles hint text styling while bar is pinned
  //      to the sticky offset (default position:sticky behavior)
  //   2) .bab--past-section on the section — engages position:fixed mode ONLY
  //      after the bundle section's bottom edge has scrolled above the natural
  //      sticky stop. This is what lets the bar persist past the section when
  //      the "Sticky for entire page" customizer option is ON. Before this
  //      change the section had position:fixed applied unconditionally, which
  //      pinned the bar to the top of the viewport from page load.
  if (tierCard) {
    var stuckState = false;
    var pastSectionState = false;
    var stuckRaf = 0;
    // Past-section fixed positioning engages when EITHER the progress bar or the
    // filter tabs are configured to stay sticky for the whole page.
    var fullPageStickyEnabled = section.classList.contains('bab--full-page-sticky') || section.classList.contains('bab--filter-full-page');
    function checkStuck() {
      var stickyTop = parseInt(getComputedStyle(tierCard).top) || 0;
      var rect = tierCard.getBoundingClientRect();
      var shouldStick = Math.abs(rect.top - stickyTop) < 2;
      if (shouldStick !== stuckState) {
        stuckState = shouldStick;
        if (shouldStick) tierCard.classList.add('is-stuck');
        else tierCard.classList.remove('is-stuck');
      }
      if (fullPageStickyEnabled) {
        // Section has scrolled past when its bottom edge is above where the
        // bar naturally pins (stickyTop + barHeight). Crossing this point is
        // exactly where CSS position:sticky would release; we take over with
        // position:fixed so the bar continues to ride at the top.
        var sectionBottom = section.getBoundingClientRect().bottom;
        var barHeight = tierCard.offsetHeight || 0;
        var shouldPin = sectionBottom < stickyTop + barHeight;
        if (shouldPin !== pastSectionState) {
          pastSectionState = shouldPin;
          if (shouldPin) section.classList.add('bab--past-section');
          else section.classList.remove('bab--past-section');
        }
      }
    }
    window.addEventListener('scroll', function() {
      if (stuckRaf) return;
      stuckRaf = requestAnimationFrame(function() { stuckRaf = 0; checkStuck(); });
    }, { passive: true });
    window.addEventListener('resize', checkStuck, { passive: true });
    checkStuck();
  }

  // Mirror the legacy top-bar progress fill if the merchant still has it enabled
  // (kept for backwards-compat with the standalone slim bar — harmless if absent)
  if (topBar && tierCard && 'IntersectionObserver' in window) {
    var topObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting && selected.size > 0) {
          topBar.classList.add('is-visible');
          topBar.setAttribute('aria-hidden', 'false');
        } else {
          topBar.classList.remove('is-visible');
          topBar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    topObserver.observe(tierCard);
  }

  // ============ CART ADD ============
  function performCartAdd() {
    pendingCartAdd = true;
    if (addBtn.getAttribute('data-state')) {
      // Defensive: prevent double-fire
    }
    addBtn.setAttribute('data-state', 'loading');
    if (fakeCartConfirm) fakeCartConfirm.setAttribute('data-state', 'loading');

    // ===== ATTRIBUTION: compute current bundle subtotal + tier reached =====
    var attrSubtotal = 0;
    selected.forEach(function(it) { if (!it.fromPopup) attrSubtotal += it.price; });
    var attrTier = 'none';
    for (var ti = subtotalTiers.length - 1; ti >= 0; ti--) {
      if (attrSubtotal >= subtotalTiers[ti].cents) { attrTier = 'tier-' + subtotalTiers[ti].id; break; }
    }
    var attrItemCount = 0;
    selected.forEach(function(it) { if (!it.fromPopup) attrItemCount++; });

    // Paid items + upsell free items (tagged so Shopify discount zeros them).
    // F1 hardening: drop any fromPopup line whose variant is not a currently-offered
    // popup gift before it can be sent to the cart as `_gift='upsell-free'`.
    var items = Array.from(selected.values()).filter(function(item) {
      return !item.fromPopup || popupVariantAllowlist[item.variantId];
    }).map(function(item) {
      var props = {
        _bundle: 'bundle',
        _market: market,
        _source: bundleSource,
        _bundle_id: bundleSessionId,
        _bundle_tier: attrTier,
        _bundle_position: String(itemAddOrder.get(item.variantId) != null ? itemAddOrder.get(item.variantId) : 0)
      };
      if (item.fromPopup) props._gift = 'upsell-free';
      return { id: item.variantId, quantity: 1, properties: props };
    });

    // Free gifts — skip decorative ones (Rebuy handles those via Smart Cart)
    giftsActive.forEach(function(gift) {
      if (gift.decorative) return;
      items.push({
        id: gift.variantId,
        quantity: 1,
        properties: {
          _bundle: 'bundle',
          _market: market,
          _source: bundleSource,
          _bundle_id: bundleSessionId,
          _bundle_tier: attrTier,
          _gift: 'tier-' + gift.tier
        }
      });
    });

    // ===== Cart-level attributes (whole-order metadata for reports) =====
    // Set via separate /cart/update.js call so they survive cart additions
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'bundle_order': 'true',
            'bundle_source': bundleSource,
            'bundle_id': bundleSessionId,
            'bundle_tier_reached': attrTier,
            'bundle_items_count': String(attrItemCount),
            'bundle_market': market
          }
        })
      }).catch(function() {}); // fire-and-forget — line item props are the source of truth
    } catch (e) {}

    // ===== Analytics events for GA4 / Meta / Klaviyo (best-effort) =====
    try {
      var bundleValue = attrSubtotal / 100; // paid subtotal in major currency units
      var eventPayload = {
        source: bundleSource,
        bundle_id: bundleSessionId,
        tier_reached: attrTier,
        items_count: attrItemCount,
        subtotal: bundleValue,
        // Standard monetary fields so GA4 + Meta can do value-based reporting /
        // ROAS / value optimization (Klaviyo's own $value is added on its push).
        value: bundleValue,
        currency: currencyCode,
        market: market,
        products: items.map(function(it) { return { variant_id: it.id }; })
      };
      // GA4 / GTM dataLayer
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'bundle_added_to_cart' }, eventPayload));
      }
      // Meta Pixel
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'BundleAddedToCart', eventPayload);
      }
      // Klaviyo / generic analytics shim — Klaviyo keys its value aggregation
      // ($X per recipient, value-based flow splits) off the special $value
      // property, so layer it on here without polluting the GA4/Meta payloads.
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Bundle Added To Cart', Object.assign({ '$value': bundleValue }, eventPayload)]);
      }
      // Custom event for any other listeners
      document.dispatchEvent(new CustomEvent('bab:bundle_added_to_cart', { detail: eventPayload }));
    } catch (e) {}

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      if (r.status === 429) {
        var err = new Error('rate_limited');
        err.code = 429;
        throw err;
      }
      if (!r.ok) {
        var err2 = new Error('cart_add_failed');
        err2.code = r.status;
        throw err2;
      }
      return r.json();
    })
    .then(function() {
      addBtn.setAttribute('data-state', 'success');

      // Refresh cart counters in the theme header
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function() {});

      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('rebuy:cart.update'));

      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'zudo_bundle_added_to_cart',
          bundle_count: selected.size,
          gifts_count: giftsActive.size,
          bundle_subtotal_cents: Array.from(selected.values()).reduce(function(s, i) { return i.fromPopup ? s : s + i.price; }, 0),
          market: market,
          checkout_type: checkoutType
        });
      } catch (e) {}

      setTimeout(function() {
        pendingCartAdd = false;
        addBtn.removeAttribute('data-state');
        if (fakeCartConfirm) fakeCartConfirm.removeAttribute('data-state');
        selected.clear();
        giftsActive.clear();
        cards.forEach(function(c) { c.classList.remove('is-selected'); });
        section.querySelectorAll('.bab__popup-product.is-added').forEach(function(p) { p.classList.remove('is-added'); });
        updateSummary();
        closeFakeCart();

        // Navigate based on checkout type setting
        if (checkoutType === 'checkout') {
          window.location.href = '/checkout';
          return;
        }

        var cartTrigger = document.querySelector('.js-drawer-open-cart');
        if (cartTrigger) {
          cartTrigger.click();
        } else {
          window.location.href = '/cart';
        }
      }, 1600);
    })
    .catch(function(err) {
      pendingCartAdd = false;
      addBtn.removeAttribute('data-state');
      if (fakeCartConfirm) fakeCartConfirm.removeAttribute('data-state');
      var msg;
      if (err && err.code === 429) {
        msg = 'You\'re moving fast! Shopify is rate-limiting requests on this preview. Wait 10 seconds and try again.';
      } else if (err && err.code === 422) {
        msg = 'One of the products in your bundle is out of stock. Try removing it and adding a different piece.';
      } else {
        msg = 'Sorry — we couldn\'t add the bundle to your cart. Please try again.';
      }
      alert(msg);
    });
  }

  addBtn.addEventListener('click', function() {
    if (selected.size < minItems) return;
    if (addBtn.getAttribute('data-state')) return;
    if (fakeCartPreview && fakeCartModal) {
      openFakeCart();
    } else {
      performCartAdd();
    }
  });

  if (fakeCartConfirm) {
    fakeCartConfirm.addEventListener('click', function() {
      if (fakeCartConfirm.getAttribute('data-state')) return;
      performCartAdd();
    });
  }

  // In-bar CTA (inside the sticky dark teal tier bar) — same behavior as footer CTA
  if (barCta) {
    barCta.addEventListener('click', function() {
      if (selected.size < minItems) return;
      if (addBtn && addBtn.getAttribute('data-state')) return;
      if (fakeCartPreview && fakeCartModal) {
        openFakeCart();
      } else {
        performCartAdd();
      }
    });
  }

  // ============ SELF-CONTAINED QUICK-VIEW ============
  // No dependency on theme.preloadProductModal — builds the modal from data already
  // present in the card DOM. Reliable across page templates, no async theme.js races.
  //
  // Two distinct flows depending on the card:
  //   * Color-only card  → modal mirrors the card state and the Add CTA is a
  //                        shortcut for the card's data-bab-toggle button.
  //   * Multi-option card → modal renders one picker per option (Size, Material,
  //                        Letter, …). The Add CTA stays disabled until every
  //                        option is selected; clicking it adds the matching
  //                        variant to `selected` directly. If the chosen variant
  //                        is already in the bundle the CTA becomes "Remove".
  (function initQuickView() {
    var qvModal = document.getElementById('bab-qv-modal');
    if (!qvModal) return; // safety guard — modal is always rendered now

    var qvGalleryTrack = qvModal.querySelector('[data-qv-gallery-track]');
    var qvGalleryDots  = qvModal.querySelector('[data-qv-dots]');
    var qvPrev         = qvModal.querySelector('[data-qv-prev]');
    var qvNext         = qvModal.querySelector('[data-qv-next]');
    var qvSave         = qvModal.querySelector('[data-qv-save]');
    var qvTitle        = qvModal.querySelector('[data-qv-title]');
    var qvRating       = qvModal.querySelector('[data-qv-rating]');
    var qvPrice        = qvModal.querySelector('[data-qv-price]');
    var qvCompare      = qvModal.querySelector('[data-qv-compare]');
    var qvSwatches     = qvModal.querySelector('[data-qv-swatches]');
    var qvOptions      = qvModal.querySelector('[data-qv-options]');
    var qvStock        = qvModal.querySelector('[data-qv-stock]');
    var qvCta          = qvModal.querySelector('[data-qv-cta]');
    var qvLink         = qvModal.querySelector('[data-qv-link]');
    var qvCloses       = qvModal.querySelectorAll('[data-qv-close]');
    // Nested size-guide overlay (always rendered in Liquid; populated per-card on open)
    var qvSizeGuide        = qvModal.querySelector('[data-qv-size-guide-panel]');
    var qvSizeGuideBody    = qvModal.querySelector('[data-qv-size-guide-body]');
    var qvSizeGuideCloseEl = qvModal.querySelector('[data-qv-size-guide-close]');

    // Editable text strings (read once on init from the modal's initial Liquid)
    var TXT_IN_STOCK         = qvStock ? qvStock.textContent.trim() : 'In stock - ready to bundle';
    var TXT_OOS_LINE         = (qvModal.dataset.oosMsg) || 'This variant is currently sold out.';
    var TXT_CTA              = qvCta ? qvCta.textContent.trim() : 'Add to Bundle';
    var TXT_CTA_ADDED        = 'Added to Bundle ✓';
    var TXT_CTA_OOS          = 'Out of Stock';
    // Multi-option specific strings (read from data attributes on the section to
    // keep the customizer copy authoritative; fall back to sensible defaults).
    // Two distinct unavailable states matching the faith-pdp pattern:
    //   * "Sold Out"     — variant exists but currently 0 stock
    //   * "Unavailable"  — variant combination doesn't exist (we don't carry it)
    var TXT_SELECT_OPTS      = section.dataset.qvSelectOptionsText || 'Select options';
    var TXT_REMOVE           = section.dataset.qvRemoveText || 'Remove from Bundle';
    var TXT_CTA_UNAVAILABLE  = section.dataset.qvUnavailableText || 'Unavailable';
    var TXT_UNAVAILABLE_LINE = section.dataset.qvUnavailableLineText || 'This combination is unavailable.';
    // Size guide visibility + copy. Master toggle (`showSizeGuideLink`) lets the
    // merchant hide the size guide link entirely without removing per-product
    // metafields. Per-card `data-has-size-guide` determines whether the link
    // appears for a given product.
    var SHOW_SIZE_GUIDE_LINK = section.dataset.showSizeGuideLink !== 'false';
    var TXT_SIZE_GUIDE_LINK  = section.dataset.sizeGuideLinkText || 'Size guide';

    var activeCard = null;
    var gallerySlideCount = 0;
    // Multi-option state. Reset every time the modal opens.
    var qvIsMulti = false;
    var qvSelectedOptions = {}; // { optionName: value, ... }
    var qvProductOptions = [];  // [{ name, position, values: [] }]
    var qvVariants = [];        // [{ id, price, compare, available, options: [...], image, title }]

    // Shared helper — rewrite a Shopify CDN URL to use a different ?width= value.
    // Used by buildGallery() AND every place that re-assigns a modal slide image
    // (swatch click, updateQvCta variant lookup). Variant images are captured at
    // width=400 in data-variants / data-variant-image for cart-thumbnail use, so
    // when those URLs feed the full-screen modal we have to upgrade them to 1000
    // to match the rest of the gallery resolution.
    function upgradeWidth(u, targetW) {
      if (!u) return u;
      if (/[?&]width=/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + targetW);
      return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + targetW;
    }

    function buildGallery(card) {
      qvGalleryTrack.innerHTML = '';
      qvGalleryDots.innerHTML = '';
      var imgs = [];
      try { imgs = JSON.parse(card.dataset.allImages || '[]'); } catch (e) { imgs = []; }
      // Always include the currently-displayed card image first if not already
      // present in product.images. Two earlier rounds of work:
      //   v1 (filename-only string compare): missed the `?width=` suffix
      //        difference between card src and product-image src, so the card
      //        was prepended as a duplicate.
      //   v2 (filename + ?v= version compare): correctly identifies "same image,
      //        different width" as a match and skips the duplicate prepend.
      // When we DO need to prepend (the variant has an image not attached to
      // the product — rare), upgrade the URL to width=1000 so the first slide
      // doesn't render softer than the rest of the gallery (which is at 1000
      // via the data-all-images Liquid capture).
      // NOTE: upgradeWidth() is defined at outer modal scope so updateQvCta()
      // and the swatch handlers can call the same helper when they overwrite
      // slide 0 with a variant.image (captured at width=400 in data-variants).
      // Without those outer-scope wrappers, slide 0 would silently downgrade
      // to width=400 even when this function ran correctly.
      var primary = card.querySelector('.bab__card-image');
      var primarySrc = primary ? primary.src : '';
      function imgKey(u) {
        if (!u) return '';
        var path = u.split('?')[0];
        var filename = path.substring(path.lastIndexOf('/') + 1);
        var v = '';
        var m = u.match(/[?&]v=([^&]+)/);
        if (m) v = m[1];
        return filename + '__v' + v;
      }
      var primaryKey = imgKey(primarySrc);
      var alreadyPresent = imgs.some(function(s) { return imgKey(s) === primaryKey; });
      if (primarySrc && !alreadyPresent) imgs.unshift(upgradeWidth(primarySrc, 1000));
      if (!imgs.length && primarySrc) imgs = [upgradeWidth(primarySrc, 1000)];
      gallerySlideCount = imgs.length;

      imgs.forEach(function(src, i) {
        var slide = document.createElement('div');
        slide.className = 'bab__qv-gallery-slide';
        var im = document.createElement('img');
        im.src = src;
        im.alt = card.dataset.title || '';
        im.loading = i === 0 ? 'eager' : 'lazy';
        slide.appendChild(im);
        qvGalleryTrack.appendChild(slide);

        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bab__qv-gallery-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function() { scrollGalleryTo(i); });
        qvGalleryDots.appendChild(dot);
      });

      updateArrowVisibility();
      // Hide arrows/dots if only 1 image
      if (imgs.length <= 1) {
        qvPrev.classList.add('is-hidden');
        qvNext.classList.add('is-hidden');
        qvGalleryDots.style.display = 'none';
      } else {
        qvGalleryDots.style.display = 'flex';
      }
    }

    function scrollGalleryTo(index) {
      var slideWidth = qvGalleryTrack.clientWidth;
      qvGalleryTrack.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    }

    function updateArrowVisibility() {
      if (gallerySlideCount <= 1) return;
      var idx = Math.round(qvGalleryTrack.scrollLeft / qvGalleryTrack.clientWidth);
      qvPrev.classList.toggle('is-hidden', idx <= 0);
      qvNext.classList.toggle('is-hidden', idx >= gallerySlideCount - 1);
      // Update active dot
      qvGalleryDots.querySelectorAll('.bab__qv-gallery-dot').forEach(function(d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    qvGalleryTrack.addEventListener('scroll', updateArrowVisibility, { passive: true });
    qvPrev.addEventListener('click', function() {
      var idx = Math.round(qvGalleryTrack.scrollLeft / qvGalleryTrack.clientWidth);
      scrollGalleryTo(Math.max(0, idx - 1));
    });
    qvNext.addEventListener('click', function() {
      var idx = Math.round(qvGalleryTrack.scrollLeft / qvGalleryTrack.clientWidth);
      scrollGalleryTo(Math.min(gallerySlideCount - 1, idx + 1));
    });

    // Helper: remove all children from a node (safer than .innerHTML = '').
    function clearChildren(node) {
      while (node && node.firstChild) node.removeChild(node.firstChild);
    }

    // Determines which non-color option pickers exist. Color is handled by the
    // existing swatch UI above so we only render pickers for non-color options.
    function getNonColorOptions() {
      return qvProductOptions.filter(function(o) {
        var n = (o.name || '').toLowerCase();
        return n.indexOf('color') === -1 && n.indexOf('colour') === -1;
      });
    }
    // Classifies an option value against the current selection. Three states:
    //   * 'available' — a variant with this combo exists AND has stock
    //   * 'soldout'   — a variant with this combo exists but is OOS
    //   * 'unavailable' — no such variant exists (we don't carry this combination)
    // This mirrors the faith-pdp logic so the bundle modal stays visually
    // consistent with the regular product page (the user flagged that the
    // current "Out of Stock" wording was misleading for combos that don't
    // exist at all, e.g. Black + 1 mm Cable Chain on the Best Sellers bundle).
    function classifyOptionValue(optionName, value) {
      var anyExists = false;
      for (var i = 0; i < qvVariants.length; i++) {
        var v = qvVariants[i];
        var optionMatches = true;
        for (var j = 0; j < qvProductOptions.length; j++) {
          var on = qvProductOptions[j].name;
          if (on === optionName) {
            if (v.options[j] !== value) { optionMatches = false; break; }
          } else if (qvSelectedOptions[on] != null) {
            if (v.options[j] !== qvSelectedOptions[on]) { optionMatches = false; break; }
          }
        }
        if (optionMatches) {
          anyExists = true;
          if (v.available) return 'available';
        }
      }
      return anyExists ? 'soldout' : 'unavailable';
    }
    function renderOptionPickers() {
      clearChildren(qvOptions);
      // Render non-color option groups for ANY product that has them, so the
      // modal looks the same whether the customer can change the value or not
      // (single-value products like Jaan Heart Locket show the size as a
      // pre-selected button, multi-value products show all options to pick).
      // updateMultiOptionState (below) handles the is-active class for both.
      var nonColorOpts = getNonColorOptions();
      var cardHasSizeGuide = SHOW_SIZE_GUIDE_LINK
        && activeCard
        && activeCard.dataset.hasSizeGuide === 'true'
        && !!activeCard.querySelector('[data-bab-size-chart]');
      nonColorOpts.forEach(function(option, optionIdx) {
        var group = document.createElement('div');
        group.className = 'bab__qv-option-group';
        group.setAttribute('data-qv-option-name', option.name);

        var label = document.createElement('div');
        label.className = 'bab__qv-option-label';
        // The option name needs its own span so the size guide link can be
        // appended after the selected-value subtitle without textContent
        // wiping it.
        var nameSpan = document.createElement('span');
        nameSpan.textContent = option.name;
        label.appendChild(nameSpan);
        var sel = document.createElement('span');
        sel.className = 'bab__qv-option-selected';
        sel.setAttribute('data-qv-option-selected', option.name);
        label.appendChild(sel);
        // Inline size guide trigger — only render on the FIRST non-color option
        // group (to avoid duplicates if a product has multiple sub-options like
        // "Ring Size" + "Engraving"), and only when the card carries a size
        // chart template element.
        if (cardHasSizeGuide && optionIdx === 0) {
          var sgLink = document.createElement('button');
          sgLink.type = 'button';
          sgLink.className = 'bab__qv-size-guide-link';
          sgLink.textContent = TXT_SIZE_GUIDE_LINK;
          sgLink.setAttribute('aria-label', TXT_SIZE_GUIDE_LINK);
          sgLink.addEventListener('click', function(e) {
            e.preventDefault();
            openSizeGuide();
          });
          label.appendChild(sgLink);
        }
        group.appendChild(label);

        var btnsWrap = document.createElement('div');
        btnsWrap.className = 'bab__qv-option-buttons';
        (option.values || []).forEach(function(value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bab__qv-option-btn';
          btn.textContent = value;
          btn.setAttribute('data-qv-option-value', value);
          btn.setAttribute('aria-label', option.name + ' ' + value);
          btn.addEventListener('click', function() {
            qvSelectedOptions[option.name] = value;
            updateMultiOptionState();
          });
          btnsWrap.appendChild(btn);
        });
        group.appendChild(btnsWrap);
        qvOptions.appendChild(group);
      });
    }

    // ---- Size guide overlay handlers ----
    // Source HTML comes from a <template data-bab-size-chart> embedded by Liquid
    // inside each card whose product has one of the size_chart metafields. We
    // clone the template's content node-by-node into the overlay body — never
    // setting innerHTML — so this is safe even though metafield content is
    // arbitrary HTML (it was authored by the merchant, not the customer).
    function openSizeGuide() {
      if (!qvSizeGuide || !qvSizeGuideBody || !activeCard) return;
      var tpl = activeCard.querySelector('[data-bab-size-chart]');
      if (!tpl || !tpl.content) return;
      clearChildren(qvSizeGuideBody);
      var fragmentNodes = tpl.content.childNodes;
      for (var i = 0; i < fragmentNodes.length; i++) {
        qvSizeGuideBody.appendChild(fragmentNodes[i].cloneNode(true));
      }
      qvSizeGuide.classList.add('is-open');
      qvSizeGuide.setAttribute('aria-hidden', 'false');
      babActivateFocusTrap(qvSizeGuide);
    }
    function closeSizeGuide() {
      if (!qvSizeGuide) return;
      var focused = qvSizeGuide.contains(document.activeElement) ? document.activeElement : null;
      if (focused && typeof focused.blur === 'function') focused.blur();
      qvSizeGuide.classList.remove('is-open');
      qvSizeGuide.setAttribute('aria-hidden', 'true');
      clearChildren(qvSizeGuideBody);
      babReleaseFocusTrap(qvSizeGuide);
    }
    if (qvSizeGuideCloseEl) {
      qvSizeGuideCloseEl.addEventListener('click', closeSizeGuide);
    }
    // Clicking outside the size guide content (but still inside the QV panel) closes it
    if (qvSizeGuide) {
      qvSizeGuide.addEventListener('click', function(e) {
        if (e.target === qvSizeGuide) closeSizeGuide();
      });
    }
    // Re-renders option button states (active / soldout / unavailable) based on
    // qvSelectedOptions, then updates price, image, stock label, and CTA.
    function updateMultiOptionState() {
      // Runs for both single-option and multi-option products. For single-option
      // products it just sets the subtitle + is-active on the one button; for
      // multi-option it also classifies the soldout/unavailable states.
      var groups = qvOptions.querySelectorAll('.bab__qv-option-group');
      groups.forEach(function(group) {
        var optionName = group.getAttribute('data-qv-option-name');
        var sel = group.querySelector('[data-qv-option-selected]');
        if (sel) sel.textContent = qvSelectedOptions[optionName] != null
          ? '· ' + qvSelectedOptions[optionName]
          : '';
        var btns = group.querySelectorAll('.bab__qv-option-btn');
        btns.forEach(function(btn) {
          var value = btn.getAttribute('data-qv-option-value');
          btn.classList.toggle('is-active', qvSelectedOptions[optionName] === value);
          var status = classifyOptionValue(optionName, value);
          btn.classList.toggle('is-soldout', status === 'soldout');
          btn.classList.toggle('is-unavailable', status === 'unavailable');
        });
      });
      updateQvCta();
    }
    // Color swatch picks for multi-option products: drive a Color value in
    // qvSelectedOptions. Color-only products keep their existing flow where the
    // swatch click on the card directly toggles the active state.
    function handleQvSwatchClick(card, sourceSwatch, cloneEl) {
      qvSwatches.querySelectorAll('.bab__qv-swatch').forEach(function(s) { s.classList.remove('is-active'); });
      cloneEl.classList.add('is-active');
      if (qvIsMulti) {
        var colorOpt = qvProductOptions.find(function(o) {
          var n = (o.name || '').toLowerCase();
          return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
        });
        if (colorOpt) {
          var pos = colorOpt.position - 1;
          var variantId = parseInt(sourceSwatch.dataset.variantId, 10);
          var match = qvVariants.find(function(v) { return v.id === variantId; });
          if (match) {
            var newColor = match.options[pos];
            qvSelectedOptions[colorOpt.name] = newColor;
            // Auto-pick available non-color options for the new colour so the
            // customer doesn't land on a Sold Out / Unavailable state just from
            // a colour switch. Example: customer is on Silver / 1 mm Cable
            // Chain (available), clicks Matte Black — we don't carry Black +
            // 1 mm Cable Chain, so we auto-switch the size to 3 mm Curb Chain
            // (which Black DOES come in). The explicit Unavailable / Sold Out
            // states still fire if the customer directly clicks a bad size.
            var currentVariant = findVariantBySelection(card, qvSelectedOptions);
            if (!currentVariant || !currentVariant.available) {
              var bestVariant = qvVariants.find(function(v) {
                return v.options[pos] === newColor && v.available;
              });
              // Fallback: if no available variant exists for this colour, pick
              // ANY variant of this colour (even OOS) so non-color selections
              // are at least realistic combos rather than dead ones.
              if (!bestVariant) {
                bestVariant = qvVariants.find(function(v) {
                  return v.options[pos] === newColor;
                });
              }
              if (bestVariant) {
                qvProductOptions.forEach(function(opt, i) {
                  var optN = (opt.name || '').toLowerCase();
                  if (optN.indexOf('color') === -1 && optN.indexOf('colour') === -1) {
                    qvSelectedOptions[opt.name] = bestVariant.options[i];
                  }
                });
              }
            }
          }
        }
        var firstSlide = qvGalleryTrack.querySelector('.bab__qv-gallery-slide img');
        if (firstSlide && sourceSwatch.dataset.variantImage) firstSlide.src = upgradeWidth(sourceSwatch.dataset.variantImage, 1000);
        scrollGalleryTo(0);
        updateMultiOptionState();
        return;
      }
      // Color-only flow: mirror the card swatch click so the card state stays
      // authoritative (existing behaviour preserved).
      sourceSwatch.click();
      setTimeout(function() {
        var freshImg = card.querySelector('.bab__card-image');
        var freshPrice = card.querySelector('.bab__card-price');
        var freshCompare = card.querySelector('.bab__card-compare');
        var firstSlide2 = qvGalleryTrack.querySelector('.bab__qv-gallery-slide img');
        if (firstSlide2 && freshImg) firstSlide2.src = upgradeWidth(freshImg.src, 1000);
        scrollGalleryTo(0);
        if (freshPrice) qvPrice.textContent = freshPrice.textContent.trim();
        qvCompare.textContent = freshCompare ? freshCompare.textContent.trim() : '';
        updateQvCta();
      }, 50);
    }

    function openQv(card) {
      activeCard = card;
      qvIsMulti = isMultiOptionCard(card);
      qvSelectedOptions = {};
      qvVariants = parseCardVariants(card);
      qvProductOptions = parseCardProductOptions(card);

      var handle = card.dataset.productHandle;
      var title = card.dataset.title || '';
      var priceEl = card.querySelector('.bab__card-price');
      var compareEl = card.querySelector('.bab__card-compare');
      var saveBadgeEl = card.querySelector('.bab__card-badge:not(.bab__card-badge--popular):not(.bab__card-badge--new)');

      buildGallery(card);

      qvTitle.textContent = title;
      qvPrice.textContent = priceEl ? priceEl.textContent.trim() : '';
      qvCompare.textContent = compareEl ? compareEl.textContent.trim() : '';
      if (qvLink) qvLink.href = '/products/' + handle;

      if (saveBadgeEl && saveBadgeEl.textContent.trim().indexOf('SAVE') === 0) {
        qvSave.textContent = saveBadgeEl.textContent.trim();
        qvSave.classList.add('is-visible');
      } else {
        qvSave.classList.remove('is-visible');
      }

      // Clone the Okendo rating widget from this card into the modal. Okendo
      // outputs trusted HTML (their script controls the source), so cloning
      // their rendered nodes into the modal is the standard pattern.
      if (qvRating) {
        var ratingSrc = card.querySelector('[data-bab-rating-source]');
        clearChildren(qvRating);
        if (ratingSrc) {
          Array.prototype.slice.call(ratingSrc.childNodes).forEach(function(n) {
            qvRating.appendChild(n.cloneNode(true));
          });
          try {
            if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidgets === 'function') {
              window.okeWidgetApi.initWidgets();
            }
          } catch (e) {}
        }
      }

      clearChildren(qvSwatches);
      var cardSwatches = card.querySelectorAll('.color-swatch');
      cardSwatches.forEach(function(sw) {
        var clone = document.createElement('button');
        clone.type = 'button';
        clone.className = 'bab__qv-swatch';
        if (sw.classList.contains('is-active')) clone.classList.add('is-active');
        // For multi-option products, never mark a swatch disabled here. The
        // card swatch's is-disabled reflects the FIRST variant of that colour,
        // which may be OOS while another size of the same colour is in stock.
        // Modal availability is decided per option combination, so we let the
        // customer try every colour and surface OOS via the Size buttons + CTA.
        if (!qvIsMulti && sw.classList.contains('is-disabled')) clone.classList.add('is-disabled');
        var bg = sw.style.backgroundColor || '';
        var bgImg = sw.style.backgroundImage || '';
        if (bg) clone.style.backgroundColor = bg;
        if (bgImg) clone.style.backgroundImage = bgImg;
        if (sw.style.order) clone.style.order = sw.style.order; // mirror swatch-priority order into the modal so card + modal match
        clone.setAttribute('aria-label', sw.getAttribute('aria-label') || sw.title || '');
        clone.addEventListener('click', function() {
          if (clone.classList.contains('is-disabled')) return;
          handleQvSwatchClick(card, sw, clone);
        });
        qvSwatches.appendChild(clone);
      });

      // Seed selected options for ANY product that has options (not just
      // multi-option). This populates the static informational labels on
      // single-value option rows (e.g. "SIZE · 1 mm Cable Chain"). Priority
      // order is the same regardless:
      //   1. Default variant (always available — selected_or_first_available)
      //   2. If the product already has a variant in the bundle, override with it
      //      so the CTA can show "Remove from Bundle"
      //   3. (Multi-option only) If the customer changed the card colour swatch
      //      BEFORE opening, prefer an AVAILABLE variant of that colour for
      //      non-colour options. Card swatches hold the first variant of each
      //      colour (which is often OOS) so we don't blindly seed from the
      //      swatch's variant id. Skipped for non-multi-option products because
      //      there's no interactive picker to re-seed against.
      if (qvProductOptions.length > 0) {
        var seedVariant = null;
        var productHandle = card.dataset.productHandle;
        var defId = parseInt(card.dataset.defaultVariantId, 10);
        if (defId) seedVariant = qvVariants.find(function(v) { return v.id === defId; });
        selected.forEach(function(item) {
          if (item.productHandle === productHandle && !item.fromPopup) {
            var bundleVariant = qvVariants.find(function(v) { return v.id === item.variantId; });
            if (bundleVariant) seedVariant = bundleVariant;
          }
        });
        if (seedVariant) {
          // Always seed from the default/bundle variant so every option has a value
          // — this is what powers the static informational labels in the modal.
          qvProductOptions.forEach(function(opt, i) {
            qvSelectedOptions[opt.name] = seedVariant.options[i];
          });
          // The colour-override + modal-swatch-sync logic below is multi-option
          // specific. Single-option products don't have an interactive picker
          // to keep in sync, so we skip it.
          if (qvIsMulti) {
            // Find the primary colour option (first option whose name contains "color")
            var colorOpt = qvProductOptions.find(function(o) {
              var n = (o.name || '').toLowerCase();
              return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
            });
            var pos = colorOpt ? colorOpt.position - 1 : -1;
            // If the card has an active swatch with a DIFFERENT colour, override
            // the colour selection and re-seed non-colour options from an available
            // variant of that colour (so the customer doesn't open to an OOS state).
            var activeSw = card.querySelector('.color-swatch.is-active');
            if (activeSw && colorOpt) {
              var swId = parseInt(activeSw.dataset.variantId, 10);
              var swVar = qvVariants.find(function(v) { return v.id === swId; });
              if (swVar && swVar.options[pos] !== seedVariant.options[pos]) {
                qvSelectedOptions[colorOpt.name] = swVar.options[pos];
                var availOfColor = qvVariants.find(function(v) {
                  return v.options[pos] === swVar.options[pos] && v.available;
                }) || swVar;
                qvProductOptions.forEach(function(opt, i) {
                  var optNm = (opt.name || '').toLowerCase();
                  if (optNm.indexOf('color') === -1 && optNm.indexOf('colour') === -1) {
                    qvSelectedOptions[opt.name] = availOfColor.options[i];
                  }
                });
              }
            }
            // Sync the modal swatch active state to the chosen colour
            if (colorOpt) {
              var chosenColor = qvSelectedOptions[colorOpt.name];
              qvSwatches.querySelectorAll('.bab__qv-swatch').forEach(function(sw, idx) {
                var cardSw = card.querySelectorAll('.color-swatch')[idx];
                if (!cardSw) { sw.classList.remove('is-active'); return; }
                var cv = qvVariants.find(function(v) { return v.id === parseInt(cardSw.dataset.variantId, 10); });
                sw.classList.toggle('is-active', !!(cv && cv.options[pos] === chosenColor));
              });
            }
          }
        }
      }

      renderOptionPickers();
      updateMultiOptionState();
      updateQvCta();

      qvModal.classList.add('is-open');
      qvModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bab-qv-open');
      babActivateFocusTrap(qvModal);
    }

    // Expose to outer scope so card click handlers can open the modal for
    // multi-option products.
    openBabQuickView = openQv;

    function updateQvCta() {
      if (!activeCard) return;

      if (qvIsMulti) {
        // ---- Multi-option flow ----
        var nonColorOpts = getNonColorOptions();
        var colorOpt = qvProductOptions.find(function(o) {
          var n = (o.name || '').toLowerCase();
          return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
        });
        var needed = nonColorOpts.map(function(o) { return o.name; });
        if (colorOpt) needed.push(colorOpt.name);
        var hasAll = needed.every(function(n) { return qvSelectedOptions[n] != null; });

        if (!hasAll) {
          qvCta.disabled = true;
          qvCta.classList.remove('is-added');
          qvCta.textContent = TXT_SELECT_OPTS;
          qvStock.textContent = '';
          qvStock.classList.remove('is-oos');
          return;
        }

        var variant = findVariantBySelection(activeCard, qvSelectedOptions);
        if (!variant) {
          // Variant DOESN'T EXIST — we don't carry this combination at all.
          // Surface this as "Unavailable" rather than "Out of Stock" so customers
          // understand the difference (matches faith-pdp / general-pdp pattern).
          qvCta.disabled = true;
          qvCta.classList.remove('is-added');
          qvCta.textContent = TXT_CTA_UNAVAILABLE;
          qvStock.textContent = TXT_UNAVAILABLE_LINE;
          qvStock.classList.add('is-oos');
          return;
        }
        if (!variant.available) {
          // Variant EXISTS but is OOS — keep "Out of Stock" wording so customers
          // know it could come back in stock (vs unavailable which never will).
          qvCta.disabled = true;
          qvCta.classList.remove('is-added');
          qvCta.textContent = TXT_CTA_OOS;
          qvStock.textContent = TXT_OOS_LINE;
          qvStock.classList.add('is-oos');
          qvPrice.textContent = formatMoney(variant.price);
          qvCompare.textContent = (variant.compare > variant.price) ? formatMoney(variant.compare) : '';
          return;
        }
        qvPrice.textContent = formatMoney(variant.price);
        qvCompare.textContent = (variant.compare > variant.price) ? formatMoney(variant.compare) : '';
        if (variant.image) {
          // variant.image is captured at width=400 in data-variants (cart-thumb size).
          // Upgrade to width=1000 before assigning to the modal slide — otherwise
          // the slide renders softer than the rest of the gallery, which is what
          // earlier "first photo is a bit blurry" reports were tracking.
          var firstSlide = qvGalleryTrack.querySelector('.bab__qv-gallery-slide img');
          if (firstSlide) firstSlide.src = upgradeWidth(variant.image, 1000);
        }
        var inBundle = selected.has(variant.id);
        qvCta.disabled = false;
        qvCta.classList.toggle('is-added', inBundle);
        qvCta.textContent = inBundle ? TXT_REMOVE : TXT_CTA;
        qvStock.textContent = TXT_IN_STOCK;
        qvStock.classList.remove('is-oos');
        return;
      }

      // ---- Color-only / no-option flow (existing behaviour preserved) ----
      var cardCta = activeCard.querySelector('[data-bab-toggle]');
      var isOos = cardCta && cardCta.disabled;
      var isSelected = activeCard.classList.contains('is-selected');
      qvCta.disabled = isOos;
      if (isOos) {
        qvCta.textContent = TXT_CTA_OOS;
        qvStock.textContent = TXT_OOS_LINE;
        qvStock.classList.add('is-oos');
      } else if (isSelected) {
        qvCta.textContent = TXT_CTA_ADDED;
        qvCta.classList.add('is-added');
        qvStock.textContent = TXT_IN_STOCK;
        qvStock.classList.remove('is-oos');
      } else {
        qvCta.textContent = TXT_CTA;
        qvCta.classList.remove('is-added');
        qvStock.textContent = TXT_IN_STOCK;
        qvStock.classList.remove('is-oos');
      }
    }

    function closeQv() {
      var focused = qvModal.contains(document.activeElement) ? document.activeElement : null;
      if (focused && typeof focused.blur === 'function') focused.blur();
      qvModal.classList.remove('is-open');
      qvModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bab-qv-open');
      activeCard = null;
      qvIsMulti = false;
      qvSelectedOptions = {};
      // Restore focus to the opener (clears any nested size-guide layer too)
      // BEFORE closeSizeGuide runs, so focus never lands transiently on a
      // control inside the now aria-hidden modal.
      babReleaseFocusTrap(qvModal);
      // Reset the nested size guide overlay if it was left open. Otherwise it
      // would still be visible the next time the modal opens for a product
      // that doesn't have a size guide.
      closeSizeGuide();
    }

    qvCta.addEventListener('click', function() {
      if (!activeCard || qvCta.disabled) return;
      if (qvIsMulti) {
        var variant = findVariantBySelection(activeCard, qvSelectedOptions);
        if (!variant) return;
        if (selected.has(variant.id)) {
          // Remove the matched variant directly so the customer can clear it
          // without having to leave the modal.
          selected.delete(variant.id);
          itemAddOrder.delete(variant.id);
        } else {
          // Add — variantTitle joins option values so the Review modal shows
          // a meaningful subtitle (e.g. "Gold / Size 7").
          itemAddOrder.set(variant.id, addCounter++);
          selected.set(variant.id, {
            card: activeCard,
            variantId: variant.id,
            price: variant.price,
            compare: variant.compare || variant.price,
            image: variant.image || activeCard.dataset.defaultImage,
            title: activeCard.dataset.title,
            variantTitle: variant.title || (variant.options || []).join(' / '),
            productHandle: activeCard.dataset.productHandle
          });
        }
        updateSummary();
        updateQvCta();
        if (selected.has(variant.id)) setTimeout(closeQv, 600);
        return;
      }
      // Color-only / no-option: defer to the card's data-bab-toggle button so
      // the existing toggle pathway (analytics, summary refresh) stays single-source.
      var cardCta = activeCard.querySelector('[data-bab-toggle]');
      if (cardCta) cardCta.click();
      updateQvCta();
      setTimeout(closeQv, 600);
    });

    qvCloses.forEach(function(el) { el.addEventListener('click', closeQv); });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      // ESC closes the size guide first if it's open, otherwise closes the modal.
      // Mirrors the customer's mental model: top-most layer closes first.
      if (qvSizeGuide && qvSizeGuide.classList.contains('is-open')) {
        closeSizeGuide();
        return;
      }
      if (qvModal.classList.contains('is-open')) closeQv();
    });

    var qaCards = section.querySelectorAll('.bab__card.grid-product[data-product-handle]');
    qaCards.forEach(function(card) {
      var qa = card.querySelector('.bab__card-quick');
      if (!qa) return;
      qa.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openQv(card);
      });
    });
  })();

  // ============ COLLECTION FILTER TABS ============
  // Three filter strategies are supported (set per-tab in customizer):
  //   - product_type:   case-INSENSITIVE whole-value match on product.type (data-product-type)
  //   - title_contains: case-INSENSITIVE substring on product.title (data-product-title-lc)
  //   - collection:     product handle in the tab's pre-resolved collection handle list
  // Both product_type and title_contains support comma-separated filter_value (OR semantic).
  // Tabs are keyed by block.id (NOT collection handle), so two tabs can reference the same
  // collection or keyword without conflict.
  var filterTabs = section.querySelectorAll('[data-bab-filter]');
  var tabConfig = window.__babTabConfig || [];
  var collectionTitleEl = section.querySelector('[data-bab-collection-title]');
  var grid = section.querySelector('.bab__grid');

  // Quick lookup: block.id -> tab descriptor
  var tabByKey = {};
  tabConfig.forEach(function(t) { tabByKey[t.key] = t; });

  // Splits a comma-separated filter value into trimmed non-empty tokens.
  // Used so a single tab can OR-match multiple product types or multiple title keywords —
  // e.g. filter_value="Necklace, Personalized Necklace, Faith Based Necklace" covers all three.
  function splitFilterValues(raw) {
    if (!raw) return [];
    return String(raw).split(',').map(function(s) { return s.trim(); }).filter(Boolean);
  }

  // Returns true if the given card matches the given tab descriptor.
  // For product_type and title_contains, filter_value may be a comma-separated list — match wins
  // if ANY listed value matches (OR semantic).
  //
  // Both product_type and title_contains use case-INSENSITIVE matching. This is deliberate:
  // merchants typing "necklace" in the customizer shouldn't see an empty tab just because the
  // Shopify Admin Product type field happens to be capitalized "Necklace". Silent mismatches
  // are the worst UX failure mode here.
  function cardMatchesTab(card, tab) {
    if (!card || !tab) return false;
    if (tab.filterType === 'product_type') {
      var types = splitFilterValues(tab.filterValue).map(function(t) { return t.toLowerCase(); });
      if (!types.length) return false;
      var productType = (card.dataset.productType || '').toLowerCase();
      return types.indexOf(productType) >= 0;
    }
    if (tab.filterType === 'title_contains') {
      var needles = splitFilterValues(tab.filterValue).map(function(n) { return n.toLowerCase(); });
      if (!needles.length) return false;
      var hay = card.dataset.productTitleLc || '';
      for (var i = 0; i < needles.length; i++) {
        if (hay.indexOf(needles[i]) >= 0) return true;
      }
      return false;
    }
    if (tab.filterType === 'collection') {
      var handles = tab.handles || [];
      return handles.indexOf(card.dataset.productHandle) >= 0;
    }
    return false;
  }

  var sectionHeaders = [];
  var carouselGroups = [];
  var isCarousel = grid && grid.classList.contains('scrollable-grid');
  var carouselPerRow = grid ? (grid.style.getPropertyValue('--cards-per-row') || '5') : '5';

  // Hooks up a scroll-indicator track/thumb to a horizontally scrolling row.
  // The thumb width = visible/total ratio; left = scrollLeft/maxScroll ratio.
  function attachScrollIndicator(row, track, thumb) {
    function update() {
      var sw = row.scrollWidth;
      var cw = row.clientWidth;
      if (sw <= cw + 1) { // no overflow to scroll → hide indicator
        track.classList.add('is-hidden');
        return;
      }
      track.classList.remove('is-hidden');
      var ratio = cw / sw;
      var leftPct = (row.scrollLeft / (sw - cw)) * (1 - ratio);
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.left = (leftPct * 100) + '%';
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    // Initial calc — wait a tick for layout
    requestAnimationFrame(update);
    setTimeout(update, 100);
  }
  if (grid && tabConfig.length > 0) {
    var placed = {};

    function buildGroup(label, groupCards, key) {
      if (!groupCards.length) return;
      var header = document.createElement('h3');
      header.className = 'bab__section-header';
      header.textContent = label;
      header.setAttribute('data-collection-header', key);
      sectionHeaders.push(header);

      if (isCarousel) {
        var groupWrap = document.createElement('div');
        groupWrap.className = 'bab__carousel-group';
        groupWrap.setAttribute('data-collection-group', key);
        groupWrap.appendChild(header);
        var rowWrap = document.createElement('div');
        rowWrap.className = 'grid-overflow-wrapper';
        var leftArrow = document.createElement('div');
        leftArrow.className = 'scroll-arrow left-arrow';
        leftArrow.textContent = '\u276E';
        var rightArrow = document.createElement('div');
        rightArrow.className = 'scroll-arrow right-arrow';
        rightArrow.textContent = '\u276F';
        var row = document.createElement('div');
        row.className = 'scrollable-grid bab__carousel-row';
        row.style.setProperty('--cards-per-row', carouselPerRow);
        groupCards.forEach(function(card) { row.appendChild(card); });
        rowWrap.appendChild(leftArrow);
        rowWrap.appendChild(rightArrow);
        rowWrap.appendChild(row);
        groupWrap.appendChild(rowWrap);
        // Custom scroll indicator bar under the carousel
        var scrollInd = document.createElement('div');
        scrollInd.className = 'bab__scroll-indicator';
        var scrollIndThumb = document.createElement('div');
        scrollIndThumb.className = 'bab__scroll-indicator-thumb';
        scrollInd.appendChild(scrollIndThumb);
        groupWrap.appendChild(scrollInd);
        attachScrollIndicator(row, scrollInd, scrollIndThumb);
        grid.parentNode.insertBefore(groupWrap, grid);
        carouselGroups.push(groupWrap);
      } else {
        grid.appendChild(header);
        groupCards.forEach(function(card) { grid.appendChild(card); });
      }
    }

    // Iterate tabs in customizer order. For each tab, walk the cards in master-pool
    // render order and pick the ones that match. This makes the master pool's sort
    // the single source of truth for intra-group order (no more sorting two collections).
    // Single-match: a card goes under the FIRST matching tab; subsequent tabs skip it.
    // (Multi-match would require cloning cards + re-attaching event handlers — Phase 2.)
    tabConfig.forEach(function(tab) {
      // hideInShopAll: skip the group-building step but DON'T mark any cards as placed.
      // Effect: tab button still renders + filtering still works on click, but no group
      // header appears in Shop All. Products that ONLY match this tab fall through to
      // the "More Pieces" group at the bottom. Products that ALSO match an earlier tab
      // are already placed under that tab — they're unaffected by this skip.
      if (tab.hideInShopAll) return;
      var groupCards = [];
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var h = c.dataset.productHandle;
        if (placed[h]) continue;
        if (cardMatchesTab(c, tab)) {
          groupCards.push(c);
          placed[h] = true;
        }
      }
      buildGroup(tab.label || tab.key, groupCards, tab.key);
    });

    var remaining = [];
    for (var i = 0; i < cards.length; i++) {
      if (!placed[cards[i].dataset.productHandle]) remaining.push(cards[i]);
    }
    buildGroup('More Pieces', remaining, 'other');

    if (isCarousel) grid.style.display = 'none';
  }

  // Attach scroll indicator to the main grid (used during filtered single-category view)
  var mainGridIndicator = null;
  var mainGridIndicatorThumb = null;
  if (grid && isCarousel) {
    mainGridIndicator = document.createElement('div');
    mainGridIndicator.className = 'bab__scroll-indicator is-hidden';
    mainGridIndicatorThumb = document.createElement('div');
    mainGridIndicatorThumb.className = 'bab__scroll-indicator-thumb';
    mainGridIndicator.appendChild(mainGridIndicatorThumb);
    grid.parentNode.insertBefore(mainGridIndicator, grid.nextSibling);
    attachScrollIndicator(grid, mainGridIndicator, mainGridIndicatorThumb);
  }

  function showAllHeaders() {
    sectionHeaders.forEach(function(h) { h.style.display = ''; });
    if (isCarousel) {
      // Move cards back into their carousel group rows. Mirror the single-match
      // assignment from buildGroup: a card goes back to the FIRST tab it matches.
      var rePlaced = {};
      carouselGroups.forEach(function(g) {
        var key = g.getAttribute('data-collection-group');
        var row = g.querySelector('.bab__carousel-row');
        if (!row) return;
        var tab = tabByKey[key];
        cards.forEach(function(card) {
          var h = card.dataset.productHandle;
          if (rePlaced[h]) return;
          if (key === 'other') {
            // 'other' is the catch-all — handled after the main loop below
            return;
          }
          if (tab && cardMatchesTab(card, tab)) {
            row.appendChild(card);
            rePlaced[h] = true;
          }
        });
        g.style.display = '';
      });
      // Now place leftover cards in the 'other' group, if it exists.
      var otherGroup = carouselGroups.filter(function(g) { return g.getAttribute('data-collection-group') === 'other'; })[0];
      if (otherGroup) {
        var otherRow = otherGroup.querySelector('.bab__carousel-row');
        if (otherRow) {
          cards.forEach(function(card) {
            if (!rePlaced[card.dataset.productHandle]) otherRow.appendChild(card);
          });
        }
      }
      grid.style.display = 'none';
      grid.classList.add('scrollable-grid');
      grid.style.setProperty('--cards-per-row', carouselPerRow);
      if (mainGridIndicator) mainGridIndicator.style.display = 'none';
    } else {
      carouselGroups.forEach(function(g) { g.style.display = ''; });
    }
  }
  function hideAllHeaders() {
    sectionHeaders.forEach(function(h) { h.style.display = 'none'; });
    carouselGroups.forEach(function(g) { g.style.display = 'none'; });
    if (isCarousel) {
      // Move cards back into the main grid for filtered view — keep carousel style
      cards.forEach(function(card) { grid.appendChild(card); });
      grid.style.display = '';
      grid.classList.add('scrollable-grid');
      grid.style.setProperty('--cards-per-row', carouselPerRow);
      if (mainGridIndicator) {
        mainGridIndicator.style.display = '';
        // Clear the manually-set is-hidden class — attachScrollIndicator's resize
        // handler will re-add it if the grid doesn't actually overflow.
        mainGridIndicator.classList.remove('is-hidden');
        // Recompute thumb after layout settles
        setTimeout(function() { window.dispatchEvent(new Event('resize')); }, 80);
      }
    }
  }

  // Helper: read visible label text (label span only, ignoring the count badge child).
  function tabLabelText(btn) {
    var labelEl = btn.querySelector('.bab__filter-tab-label');
    return labelEl ? labelEl.textContent.trim() : btn.textContent.trim();
  }

  if (filterTabs.length > 1) {
    filterTabs.forEach(function(tabBtn) {
      tabBtn.addEventListener('click', function() {
        if (tabBtn.classList.contains('is-empty')) return; // C4: skip empty tabs
        filterTabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tabBtn.classList.add('is-active');
        tabBtn.setAttribute('aria-selected', 'true');
        var filterKey = tabBtn.dataset.babFilter;
        var activeTab = filterKey === 'all' ? null : tabByKey[filterKey];
        cards.forEach(function(card) {
          if (!activeTab) {
            card.classList.remove('is-filtered-out');
          } else if (cardMatchesTab(card, activeTab)) {
            card.classList.remove('is-filtered-out');
          } else {
            card.classList.add('is-filtered-out');
          }
        });
        if (filterKey === 'all') {
          if (collectionTitleEl) { collectionTitleEl.style.display = 'none'; collectionTitleEl.textContent = ''; }
          section.classList.remove('bab--single-collection');
          showAllHeaders();
        } else {
          if (collectionTitleEl) { collectionTitleEl.textContent = tabLabelText(tabBtn); collectionTitleEl.style.display = ''; }
          section.classList.add('bab--single-collection');
          hideAllHeaders();
        }
        // UX: pull the freshly-filtered products into view so the shopper isn't left
        // scrolled down among the now-hidden carousels. We compute the scroll target
        // from the tabs' LIVE sticky-pin offset (getComputedStyle top) — which differs
        // desktop vs mobile — so the products land just below the pinned header stack
        // with no overshoot. For "all" we pin the tab strip itself; for a single
        // category we land the collection title just beneath the pinned tabs.
        var babTabsEl = section.querySelector('[data-bab-filter-tabs]');
        var babSentinel = section.querySelector('[data-bab-filter-tabs-sentinel]');
        if (babTabsEl) {
          var babReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // Defer past the layout reflow that hideAllHeaders/showAllHeaders triggers (it
          // fires a resize at ~80ms) so the scroll target is computed from a SETTLED
          // layout and the browser's scroll-anchoring doesn't fight us mid-reflow. We set
          // a dynamic scroll-margin equal to the pinned header stack (tier card + tabs),
          // then let scrollIntoView land the anchor precisely beneath it — no overshoot
          // on mobile OR desktop, where the sticky offsets differ.
          setTimeout(function() {
            var tabsPin = parseFloat(getComputedStyle(babTabsEl).top) || 0;
            var anchorEl, margin;
            if (filterKey === 'all' || !collectionTitleEl) {
              anchorEl = babSentinel || babTabsEl;   // Shop All: pin the tab strip at the top
              margin = tabsPin;
            } else {
              anchorEl = collectionTitleEl;           // Single category: title just below the pinned tabs
              margin = tabsPin + (babTabsEl.offsetHeight || 0) + 8;
            }
            anchorEl.style.scrollMarginTop = margin + 'px';
            anchorEl.scrollIntoView({ behavior: babReduceMotion ? 'auto' : 'smooth', block: 'start' });
          }, 120);
        }
      });
    });
    showAllHeaders();

    // ============ F8: ARROW-KEY NAVIGATION (WCAG tablist pattern) ============
    // ARIA Authoring Practices: in a tablist with role="tab" buttons, Left/Right
    // arrows move focus + activate adjacent tabs; Home/End jump to first/last.
    // Skips .is-empty tabs in the traversal (they're non-interactive) — pressing
    // → past Necklaces lands on Cuffs, not on empty Earrings. tabindex management
    // uses the "roving tabindex" pattern: the active tab has tabindex=0, the rest
    // have tabindex=-1. Tab-key navigation jumps OUT of the tablist (to the next
    // interactive element on the page) which matches user expectation.
    var activeTabsList = Array.prototype.slice.call(filterTabs);
    function applyRovingTabindex() {
      activeTabsList.forEach(function(t) {
        t.setAttribute('tabindex', t.classList.contains('is-active') ? '0' : '-1');
      });
    }
    function focusableTabs() {
      // Filter out empty tabs — they're visually dimmed and shouldn't be reachable
      // via arrow navigation (would feel like a dead-end to the keyboard user).
      return activeTabsList.filter(function(t) { return !t.classList.contains('is-empty'); });
    }
    applyRovingTabindex();
    activeTabsList.forEach(function(tabBtn) {
      tabBtn.addEventListener('keydown', function(e) {
        var key = e.key;
        if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
        e.preventDefault();
        var focusable = focusableTabs();
        if (focusable.length === 0) return;
        var currentIdx = focusable.indexOf(tabBtn);
        var nextIdx;
        if (key === 'Home') nextIdx = 0;
        else if (key === 'End') nextIdx = focusable.length - 1;
        else if (key === 'ArrowLeft') nextIdx = (currentIdx <= 0) ? focusable.length - 1 : currentIdx - 1;
        else /* ArrowRight */ nextIdx = (currentIdx >= focusable.length - 1) ? 0 : currentIdx + 1;
        var nextBtn = focusable[nextIdx];
        if (!nextBtn) return;
        nextBtn.focus();
        nextBtn.click(); // activate on arrow (per ARIA tab pattern — "automatic activation")
      });
    });
    // Re-apply roving tabindex when active tab changes (the click handler above
    // toggles .is-active classes — we listen via MutationObserver on the strip).
    var tabsContainer = section.querySelector('[data-bab-filter-tabs]');
    if (tabsContainer && 'MutationObserver' in window) {
      new MutationObserver(applyRovingTabindex).observe(tabsContainer, {
        attributes: true, attributeFilter: ['class'], subtree: true
      });
    }
  }

  // ============ C4: FILTER TAB COUNTS + STICKY ============
  // Counts populate the badge spans; empty tabs get .is-empty (click handler bails).
  // Run once — master pool is static post-render.
  function computeFilterTabCounts() {
    var allCount = 0;
    var perTab = {};
    cards.forEach(function(card) {
      allCount++;
      tabConfig.forEach(function(tab) {
        if (cardMatchesTab(card, tab)) {
          perTab[tab.key] = (perTab[tab.key] || 0) + 1;
        }
      });
    });
    var allBadge = section.querySelector('[data-bab-filter-count="all"]');
    if (allBadge) allBadge.textContent = String(allCount);
    tabConfig.forEach(function(tab) {
      var n = perTab[tab.key] || 0;
      var badge = section.querySelector('[data-bab-filter-count="' + CSS.escape(tab.key) + '"]');
      if (badge) badge.textContent = String(n);
      var btn = section.querySelector('[data-bab-filter="' + CSS.escape(tab.key) + '"]');
      if (btn) { if (n === 0) btn.classList.add('is-empty'); else btn.classList.remove('is-empty'); }
    });
  }
  computeFilterTabCounts();

  // --bab-tier-card-height keeps filter-tab top offset in sync with tier card.
  var filterTabsEl = section.querySelector('[data-bab-filter-tabs]');
  function updateTierCardHeightVar() {
    if (!tierCard) return;
    // No +buffer: the tabs pin flush against the tier card's bottom edge (closes the
    // tiny 2px gap). The tier card's higher z-index covers any sub-pixel touch, so
    // there's no visible overlap.
    section.style.setProperty('--bab-tier-card-height', (tierCard.offsetHeight || 0) + 'px');
  }
  if (tierCard) {
    updateTierCardHeightVar();
    if ('ResizeObserver' in window) new ResizeObserver(updateTierCardHeightVar).observe(tierCard);
    window.addEventListener('resize', updateTierCardHeightVar, { passive: true });
  }

  // Scroll-driven sticky check (mirrors tier card pattern). Toggles .is-stuck for shadow cue.
  if (filterTabsEl) {
    var filterStuckState = false;
    var filterStuckRaf = 0;
    function checkFilterStuck() {
      var stickyTop = parseInt(getComputedStyle(filterTabsEl).top) || 0;
      var rect = filterTabsEl.getBoundingClientRect();
      var shouldStick = Math.abs(rect.top - stickyTop) < 2;
      if (shouldStick !== filterStuckState) {
        filterStuckState = shouldStick;
        if (shouldStick) filterTabsEl.classList.add('is-stuck');
        else filterTabsEl.classList.remove('is-stuck');
      }
    }
    window.addEventListener('scroll', function() {
      if (filterStuckRaf) return;
      filterStuckRaf = requestAnimationFrame(function() { filterStuckRaf = 0; checkFilterStuck(); });
    }, { passive: true });
    window.addEventListener('resize', checkFilterStuck, { passive: true });
    checkFilterStuck();
  }

  // ============ STICKY OFFSET — account for fixed header ============
  function updateStickyOffset() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    var h = header.offsetHeight || 0;
    section.style.setProperty('--bab-sticky-offset', h + 'px');
  }
  updateStickyOffset();
  window.addEventListener('resize', updateStickyOffset);
  new MutationObserver(updateStickyOffset).observe(
    document.getElementById('SiteHeader') || document.body,
    { attributes: true, childList: true, subtree: false }
  );

  // ============ INIT ============
  // F1: Restore any previously persisted bundle before the first paint of the
  // summary. We do this BEFORE updateSummary() so the restored items count
  // toward all initial calculations (subtotal, tier unlocks, count pills).
  // restoreSelection returns the number of items restored, which we forward
  // to dataLayer for analytics so we can measure how often persistence saves
  // an abandoned bundle.
  var restoredCount = restoreSelection();
  if (restoredCount > 0) {
    // CRITICAL: pre-set the "modal already fired" flags so the first
    // updateSummary() doesn't re-trigger GWP / popup for tiers the shopper
    // already crossed in the previous session. Without this guard, returning
    // shoppers see the GWP celebration modal pop again on every reload —
    // annoying and ruins the "celebration" framing of crossing the threshold.
    // We use the same subtotalTiers + popupTrigger that updateSummary uses,
    // so the suppression logic matches the trigger logic exactly.
    var restoredSubtotal = 0;
    selected.forEach(function(item) {
      if (!item.fromPopup) restoredSubtotal += item.price;
    });
    // GWP fires when unlockedTier.id === milestoneCount (top tier crossed).
    // So suppress topTierShown if the restored subtotal is >= the top tier's threshold.
    if (subtotalTiers.length && restoredSubtotal >= subtotalTiers[subtotalTiers.length - 1].cents) {
      topTierShown = true;
    }
    // Popup fires when unlockedTier.id >= popupTrigger. Suppress if the restored
    // subtotal already crosses that tier's threshold.
    if (popupTrigger > 0) {
      var popupTriggerTier = subtotalTiers.filter(function(t) { return t.id >= popupTrigger; })[0];
      if (popupTriggerTier && restoredSubtotal >= popupTriggerTier.cents) {
        popupShown = true;
      }
    }

    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'bab_bundle_restored',
        bab_restored_items: restoredCount,
        bab_restored_subtotal_cents: restoredSubtotal,
        bab_session_id: bundleSessionId,
        bab_source: bundleSource
      });
    } catch (e) {}
  }

  // Initial state
  updateSummary();
})();
